/* eslint-disable no-self-compare */
import { useMemo, useEffect, useCallback, useState, useRef } from 'react';
//import { useLazyQuery } from '@apollo/react-hooks';
import { connect } from 'react-redux';
import { updateRecord } from '../../actions';
import { capitalize, filterJobCatalog, filterPaymentTypes } from '../../util';
const { tokenize } = require('excel-formula-tokenizer');

var FormulaParser = require('hot-formula-parser').Parser;
var sform = require('hot-formula-parser').SUPPORTED_FORMULAS;
//console.log(sform);
var parser = new FormulaParser();

const BUDGET_MULTIPLIER = 3.5;
const CURRENT_TIMESTAMP = Date.now();


const round = (v, d) => Number(Math.round(v + 'e' + d) + 'e-' + d);
const isNaN = (maybeNaN) => maybeNaN !== maybeNaN;

//excel calculation values
const CalculatorNew = props => {
  const { columns, recordType, item, data, updateRecord, config, account, formulas } = props;
  //console.log('config', config);
  let curDate = new Date();
  //const CURRENT_EXCEL_TIMESTAMP = `${curDate.getFullYear()}-${curDate.getMonth() + 1}-${curDate.getDay()}`;

  /* SLEEP FOR 1 seconds  */
  const sleep = ms => new Promise(r => setTimeout(r, ms));
  const callForSleep = async function(a) {
    //console.log("Call from ", a);
    //console.log("Before Sleeping===>", Math.floor(Date.now() / 1000));
    await sleep('1000');
    //console.log("After Sleeping===>", Math.floor(Date.now() / 1000));
  }
  //callForSleep('open');
  const indexColumn = columns.find(c => c.index);

  const flattenRequestData = data => {
    return {
      ...data.request.for, ...{
        employee_request_id: data.employee_request_id,
        request_type: data.request.request_type,
        currency: data.request.currency,
        ttc_increase_amount: data.request.ttc_increase_amount,
        ttc_increase_percentage: data.request.ttc_increase_percentage,
        payment_type: selectedItem.request.payment_type,
        payment_reason: selectedItem.request.payment_reason,
        is_gpp_eligible: data.request.is_gpp_eligible,
        gpp_increase_amount: data.request.gpp_increase_amount,
        gpp_increase_percentage: data.request.gpp_increase_percentage,
        promoted: data.request.promoted,
        promotion_job_family_name: data.request.promotion_job_family_name,
        promotion_job_subfamily_name: data.request.promotion_job_subfamily_name,
        promotion_job_name: data.request.promotion_job_name,
        promotion_pay_grade: data.request.promotion_pay_grade,
        promotion_job_grade: data.request.promotion_job_grade,
        promotion_job_grade_delta: data.request.promotion_job_grade_delta,
        promotion_incentive_target_percentage: data.request.promotion_incentive_target_percentage,
        demoted: data.request.demoted,
        mandatory_ttc_increase_percentage: data.request.mandatory_ttc_increase_percentage,
        mandatory_ttc_increase_amount: data.request.mandatory_ttc_increase_amount,
        apply_ti_harmonization: data.request.apply_ti_harmonization,
        interim_job_family_name: data.request.interim_job_family_name,
        interim_job_grade: data.request.interim_job_grade,
        interim_fte_incentive_target_amount: data.request.interim_fte_incentive_target_amount,
        interim_incentive_target_percentage: data.request.interim_incentive_target_percentage,
        interim_total_increase_amount: data.request.interim_total_increase_amount,
        interim_increase_amount_for_salincr: data.request.interim_increase_amount_for_salincr,
        interim_increase_amount_for_tih: data.request.interim_increase_amount_for_tih,
        step_1_abs: data.request.step_1_abs,
        step_1_ita: data.request.step_1_ita,
        step_1_itp: data.request.step_1_itp,
        interim_theo_itp: data.request.interim_theo_itp,
        interim_itp_situation: data.request.interim_itp_situation,
        step_2_abs_gap: data.request.step_2_abs_gap,
        step_2_ita_gap: data.request.step_2_ita_gap,
        interim_remainder_for_split: data.request.interim_remainder_for_split,
        new_fte_annual_salary: data.request.new_fte_annual_salary,
        new_fte_incentive_target_amount: data.request.new_fte_incentive_target_amount,
        new_incentive_target_percentage: data.request.new_incentive_target_percentage,
        new_fte_ttc_annual_salary: data.request.new_fte_ttc_annual_salary,
        new_itp_situation: data.request.new_itp_situation,
        new_quartile: data.request.new_quartile,
        override_manager_proposal: data.request.override_manager_proposal,
        override_fte_annual_salary: data.request.override_fte_annual_salary,
        override_fte_incentive_target_amount: data.request.override_fte_incentive_target_amount,
        override_promotion_increase: data.request.override_promotion_increase,
        override_ti_harmonization: data.request.override_ti_harmonization,
        override_fte_incentive_target_percentage: data.request.override_fte_incentive_target_percentage,
        override_fte_ttc_annual_salary: data.request.override_fte_ttc_annual_salary,
        new_position_title: data.request.new_position_title,
        interim_pay_grade: data.request.interim_pay_grade,
        interim_salary_range_min: data.request.interim_salary_range_min,
        interim_salary_range_mid: data.request.interim_salary_range_mid,
        interim_salary_range_max: data.request.interim_salary_range_max,
        new_ttc_compa_ratio: data.request.new_ttc_compa_ratio,
        interim_salary_range_spread: data.request.interim_salary_range_spread,
        ttc_increase: data.request.ttc_increase,
        ttc_increase_perc: data.request.ttc_increase_perc,
        /**Release 2 Our talent data */
        /**Release 2 our talent */
      current_combo_situation: data.request.current_combo_situation,
      promo_increase_pct_guideline_min: data.request.promo_increase_pct_guideline_min,
      promo_increase_pct_guideline_max: data.request.promo_increase_pct_guideline_max,
      promotional_increase_percentage_guideline: data.request.promotional_increase_percentage_guideline,
      rr_number: data.request.rr_number,
      case_3_12_month_actual_incentive_amount_fte: data.request.case_3_12_month_actual_incentive_amount_fte,
      override_transition_allowance_local_currency: data.request.override_transition_allowance_local_currency,
     // new_incentive_scheme,
      internalhire_off_cycle_spending: data.request.internalhire_off_cycle_spending,
      internal_hire_off_cycle_spending_euro: data.request.internal_hire_off_cycle_spending_euro,
    
      is_sip: data.request.is_sip,
      Case_One_Max_Budget_calc: data.request.Case_One_Max_Budget_calc,
      Case_one_TTC_increase_minus_Max_budget: data.request.Case_one_TTC_increase_minus_Max_budget,
      Case_one_Budget_charge: data.request.Case_one_Budget_charge,
      Case_two_TI_Increase: data.request.Case_two_TI_Increase,
      Case_two_Promotion_Budget: data.request.Case_two_Promotion_Budget,
      Case_two_Total_budget: data.request.Case_two_Total_budget,
      Case_two_Budget_charge: data.request.Case_two_Budget_charge,
      Case_three_twelve_month_Total_Target_Cash: data.request.Case_three_twelve_month_Total_Target_Cash,
      Case_three_new_TTC_Gap_to_twelve_month_TTC: data.request.Case_three_new_TTC_Gap_to_twelve_month_TTC,
      Case_three_Max_capped_transit_allowance: data.request.Case_three_Max_capped_transit_allowance,
      Case_three_Transition_allowance_total: data.request.Case_three_Transition_allowance_total,
      Case_three_Budget_charge: data.request.Case_three_Budget_charge,
      sip_case: data.request.sip_case,
      Final_Off_Cycle_Budget: data.request.Final_Off_Cycle_Budget,
      Max_Promotional_Increase : data.request.promoted ?  data.request.promo_increase_pct_guideline_max:0,
      sip_change: data.request.sip_change ? data.request.sip_change : data.request.is_sip,
      internalhire_increase_amount: data.request.internalhire_increase_amount,
      internalhire_increase_percentage: data.request.internalhire_increase_percentage,
      hiring_manager: data.request.hiring_manager,
      /* Release 3.2 - 13.1 - Starts */      
      sum_of_pay_amount: 
      (
        data.case_3_12_month_actual_incentive_amount_fte ?
        data.case_3_12_month_actual_incentive_amount_fte :
        data.request.case_3_12_month_actual_incentive_amount_fte ? 
        data.request.case_3_12_month_actual_incentive_amount_fte : 
        0
      )
      + 
      data.request.case_3_12_month_actual_incentive_amount_fte + 
      (
        data.lastYearWageHistory && data.lastYearWageHistory.addl_pay_amount ?
        data.lastYearWageHistory.addl_pay_amount :
        data.request.lastYearWageHistory && data.request.lastYearWageHistory.addl_pay_amount ? 
        data.request.lastYearWageHistory.addl_pay_amount : 
        0
      ),
      lastYearWageHistory: data.lastYearWageHistory ? data.lastYearWageHistory  : data.request.lastYearWageHistory ? data.request.lastYearWageHistory : null,
      /* Release 3.2 - 13.1 - Ends */

      /*  DMND0003988_NBS - Point #7 - Changes Starts  */
      addl_pay_amount: data.request.addl_pay_amount,
      transition_allowance: data.request.transition_allowance,
      /*  DMND0003988_NBS - Point #7 - Changes Ends  */
      }
    };
  }

  let selectedItem = props[`selected${capitalize(recordType)}`].find(e => e[indexColumn.name] === item);
  //console.log('selectedItem 123', selectedItem);
  if (recordType === 'requests' && selectedItem) {
    selectedItem = flattenRequestData(selectedItem);

    console.log(
      'OVERRIDE DEBUG:',
      {
        override_manager_proposal: selectedItem?.override_manager_proposal,
        override_fte_annual_salary: selectedItem?.override_fte_annual_salary,
        override_fte_incentive_target_amount:
          selectedItem?.override_fte_incentive_target_amount
      }
    );
    //console.log('selectedItem',selectedItem)
    //defineFormulaVars();
  }
  
  /*
   * Preserve original New ABS / New ITA values before
   * Override Manager Proposal changes them.
   *
   * This is a value snapshot, not an update/re-render guard.
   */
  const overrideOriginalValuesRef = useRef({
    item: null,
    new_fte_annual_salary: null,
    new_fte_incentive_target_amount: null,
    previousOverride: false,
    hasSnapshot: false
  });

  useEffect(() => {
    if (!selectedItem) return;

    const currentOverride =
      selectedItem.override_manager_proposal === true;

    const snapshot = overrideOriginalValuesRef.current;

    /*
     * New employee/request row.
     */
    if (snapshot.item !== item) {
      overrideOriginalValuesRef.current = {
        item,
        new_fte_annual_salary:
          selectedItem.new_fte_annual_salary,
        new_fte_incentive_target_amount:
          selectedItem.new_fte_incentive_target_amount,
        previousOverride: currentOverride,
        hasSnapshot: false
      };

      return;
    }

    /*
     * Override Manager Proposal has just been CHECKED.
     *
     * At this point selectedItem still contains the original
     * New ABS / New ITA, before updateEmployeeData() persists
     * the override calculated values.
     */
    if (currentOverride && !snapshot.previousOverride) {
      snapshot.new_fte_annual_salary =
        selectedItem.new_fte_annual_salary;

      snapshot.new_fte_incentive_target_amount =
        selectedItem.new_fte_incentive_target_amount;

      snapshot.hasSnapshot = true;
    }

    /*
     * When Override is UNCHECKED after being checked,
     * intentionally DO NOT overwrite the snapshot.
     *
     * The current data may already contain the override values.
     */
    snapshot.previousOverride = currentOverride;
  }, [item, selectedItem, data]);
  
  const hasNoDecimals = useMemo(
    () => {
      if(selectedItem){
        const { noDecimalCurrencies = [] } = config;
        let hd = noDecimalCurrencies.find(c => c === selectedItem.currency);
        return hd?hd:false;  
      }else{
        return false;
      }      
    });

    
    /*
    R2 - Admin Calculations
    defineFormulaVars() - Declare variables/functions needed for parser
    */

    const binarySearch = (array, target) => 
      {
        let left = 0;
        let right = array.length - 1;
      
        while (left <= right) 
        {
          const mid = Math.floor((left + right) / 2);
          if (array[mid] === target) 
          {
            return mid;
          }
          if (array[mid] < target) 
          {
            left = mid + 1;
          } 
          else 
          {
            right = mid - 1;
          }
        }
        return -1;
      }
    const defineFormulaVars = () =>
    {
      //callForSleep('defineFormulaVars');
        const { itpLookupTable, gppLookupTable, exchangeRates, jobGrades, countryLookupTable,increaseLookupTable } = config;
        
        /* all formula fields and functions declaration - Fields starts*/
        parser.setVariable('dateOfJoining', selectedItem.pers_start_date!==null?Date.parse(selectedItem.pers_start_date):selectedItem.pers_start_date);
        parser.setVariable('country', selectedItem.country_name);
        parser.setVariable('currentCountryCode', selectedItem.country);
        parser.setVariable('curSalary', selectedItem.fte_ttc_annual_salary);
        parser.setVariable('currentFteAbs', selectedItem.fte_annual_salary);
        parser.setVariable('currentFteIta', selectedItem.fte_incentive_target_amount);
        parser.setVariable('additionalFteAnnualPayment', selectedItem.fte_addl_ttc_amount==null?0:selectedItem.fte_addl_ttc_amount);
        parser.setVariable('currentJobGrade', selectedItem.job_grade);
        parser.setVariable('jobFamily', selectedItem.job_family_name);
        parser.setVariable('payScaleArea', selectedItem.pay_scale_area);
        parser.setVariable('overrideFteAbs', selectedItem.override_fte_annual_salary);
        parser.setVariable('overrideFteIta', selectedItem.override_fte_incentive_target_amount);
        parser.setVariable('overrideMandatoryIncrease', selectedItem.override_promotion_increase);
        parser.setVariable('overrideTiHarmonization', (selectedItem.override_ti_harmonization===undefined) ? 
         'Do not override' : selectedItem.override_ti_harmonization);
        parser.setVariable('newJobGrade', selectedItem.promotion_job_grade);
        parser.setVariable('currentItp', selectedItem.fte_incentive_target_percentage);
        parser.setVariable('currentQuartile', selectedItem.ttc_employee_quartile);
        parser.setVariable('localCurrencyCode', selectedItem.currency);
        parser.setVariable('overrideManagerProposal', selectedItem.override_manager_proposal===undefined?false:selectedItem.override_manager_proposal);
        parser.setVariable('currency',selectedItem.salary_range_min);
        parser.setVariable('currentSrMid',selectedItem.salary_range_mid);
        parser.setVariable('currentSrMax',selectedItem.salary_range_max);
        parser.setVariable('currentPayGrade',selectedItem.pay_grade);    
        parser.setVariable('TTCIncreasePercentage',(selectedItem.ttc_increase_percentage==''||selectedItem.ttc_increase_percentage===null)?0:selectedItem.ttc_increase_percentage);
        parser.setVariable('TTCIncrease',selectedItem.ttc_increase);
        parser.setVariable('TTCIncreasePerc',selectedItem.ttc_increase_perc);
        parser.setVariable('TransitionAllowance',selectedItem.transition_allowance);
             
        
        //set variables from Functions start
        parser.setVariable('finalJobFamily', selectedItem.promotion_job_family_name);
        parser.setVariable('currentSrRangeSpread', selectedItem.salary_range_spread);
        parser.setVariable('tenure', selectedItem.tenure===undefined?0:selectedItem.tenure);
        parser.setVariable('merit', selectedItem.ttc_increase_amount);
        parser.setVariable('ttc_increase_pct', selectedItem.ttc_increase_percentage);
        parser.setVariable('lumpSumTwo', selectedItem.gpp_increase_amount);
        parser.setVariable('gppGuidelineMax', selectedItem.gpp_guideline_max===undefined?0.00:selectedItem.gpp_guideline_max);
        parser.setVariable('newPayGrade', selectedItem.promotion_pay_grade);
        parser.setVariable('newJobGrade', selectedItem.promotion_job_grade);
        parser.setVariable('promoted', selectedItem.promoted);
        parser.setVariable('newTheoItp', selectedItem.promotion_incentive_target_percentage);
        parser.setVariable('mandatoryTtcIncreasePercentageDueToPromotion', selectedItem.mandatory_ttc_increase_percentage);
        parser.setVariable('mandatoryTtcIncreaseDueToPromotion', selectedItem.mandatory_ttc_increase_amount);
        parser.setVariable('applyTiHarmonization', selectedItem.apply_ti_harmonization===undefined?false:selectedItem.apply_ti_harmonization);
        parser.setVariable('harmonizationType', selectedItem.interim_harmonization_type);
        parser.setVariable('interimJobFamily', selectedItem.interim_job_family_name);
        parser.setVariable('interimJobGrade', selectedItem.interim_job_grade);
        /* DEM0079460 - Changes Starts */
        parser.setVariable('Final_City_For_Salary_Range', selectedItem.Final_City_For_Salary_Range);
        /* DEM0079460 - Changes Ends */
        parser.setVariable('newSrMin', selectedItem.interim_salary_range_min);
        parser.setVariable('newSrMid', selectedItem.interim_salary_range_mid);
        parser.setVariable('newSrMax', selectedItem.interim_salary_range_max);
        parser.setVariable('newSrRangeSpread', selectedItem.interim_salary_range_spread);
        parser.setVariable('interimFteIta', selectedItem.interim_fte_incentive_target_amount);
        parser.setVariable('interimFteItp', selectedItem.interim_incentive_target_percentage);
        parser.setVariable('totalIncreaseAmount', (selectedItem.interim_total_increase_amount==''||selectedItem.interim_total_increase_amount==null)?0:selectedItem.interim_total_increase_amount);
        parser.setVariable('increaseAmountForSalIncr', selectedItem.interim_increase_amount_for_salincr);
        parser.setVariable('increaseAmountForTih', selectedItem.interim_increase_amount_for_tih);
        parser.setVariable('stepOneAbs', selectedItem.step_1_abs);
        parser.setVariable('stepOneIta', selectedItem.step_1_ita);
        parser.setVariable('stepOneItp', selectedItem.step_1_itp);
        parser.setVariable('interimTheoItp', selectedItem.interim_theo_itp);
        parser.setVariable('interimItpSituation', selectedItem.interim_itp_situation);
        parser.setVariable('stepTwoAbsGap', selectedItem.step_2_abs_gap);
        parser.setVariable('stepTwoItaGap', selectedItem.step_2_ita_gap);
        parser.setVariable('remainderForSplit', selectedItem.interim_remainder_for_split===undefined?0:selectedItem.interim_remainder_for_split);
        parser.setVariable('newAbs', selectedItem.new_fte_annual_salary);
        parser.setVariable('newIta', selectedItem.new_fte_incentive_target_amount);
        parser.setVariable('newItp', selectedItem.new_incentive_target_percentage);
        parser.setVariable('newTtc', selectedItem.new_fte_ttc_annual_salary);
        parser.setVariable('newItpSituation', selectedItem.new_itp_situation);
        parser.setVariable('ttcCheck', selectedItem.new_ttc_check);
        parser.setVariable('newCR', selectedItem.new_ttc_compa_ratio);
        parser.setVariable('individualBudgetAmount', selectedItem.individual_budget_amount);
        parser.setVariable('individualSpendingAmount', selectedItem.individual_spending_amount);
        parser.setVariable('individualBalanceAmount', selectedItem.individual_balance_amount);
        parser.setVariable('gppBudget', selectedItem.gpp_budget);
        parser.setVariable('gppSpending', selectedItem.gpp_spending===undefined?0:selectedItem.gpp_spending);
        parser.setVariable('gppBalance', selectedItem.gpp_balance);
        parser.setVariable('overallTotalSpending', selectedItem.total_spending);
        parser.setVariable('overrideItp', selectedItem.override_fte_incentive_target_percentage);
        parser.setVariable('overrideFteTtc', selectedItem.override_fte_ttc_annual_salary);
        parser.setVariable('currentCR', selectedItem.ttc_compa_ratio);  
        parser.setVariable('exchangeRate', selectedItem.exchange_rate);
        

        //newly added excel fields updated
        parser.setVariable('isGPPEligible', selectedItem.is_gpp_eligible);
        parser.setVariable('demoted', selectedItem.demoted);
        parser.setVariable('incentivePlan', selectedItem.incentive_plan_type);
        parser.setVariable('targetBudgetOrg', selectedItem.target_budget_org);
        parser.setVariable('orgUnitFour', selectedItem.organization_unit_4);
        parser.setVariable('orgUnitThree', selectedItem.organization_unit_3);
        parser.setVariable('orgUnitTwo', selectedItem.organization_unit_2);
        parser.setVariable('orgUnitOne', selectedItem.organization_unit_1);
        parser.setVariable('lumpSumTwoPerc', selectedItem.gpp_increase_percentage);
        parser.setVariable('promoJobGradeDelta', selectedItem.promotion_job_grade_delta);
        parser.setVariable('newIncentivePlanType', selectedItem.new_incentive_plan_type);
        parser.setVariable('offCycleBudgetUpdate', selectedItem.offcycle_budget_update);
        parser.setVariable('InterimPayGrade', selectedItem.interim_pay_grade);
        parser.setVariable('hasNoDecimals', hasNoDecimals);

        //formula helper fields
        parser.setVariable('budgetMultiplier', BUDGET_MULTIPLIER);
        parser.setVariable('CURRENT_TIMESTAMP', CURRENT_TIMESTAMP);

        parser.setVariable('true', true);
        parser.setVariable('false', false);
        /* Release 3.2 - 12.2 - Starts */
        if (selectedItem.request_type != "onetime") {
          parser.setVariable('null', null);
        } 
        /* Release 3.2 - 12.2 - Ends */
        parser.setVariable('undefined', undefined);
        parser.setVariable('Infinity', Infinity);
        
        //Adding other fields to be accessed in the dynamic formula
        parser.setVariable('persNo', selectedItem.pers_no);
        parser.setVariable('firstName', selectedItem.first_name);
        parser.setVariable('lastName', selectedItem.last_name);
        parser.setVariable('fullName', selectedItem.full_name);
        parser.setVariable('nokiaID', selectedItem.nokia_id);
        parser.setVariable('employmentStatus', selectedItem.employment_status);
        parser.setVariable('workEmail', selectedItem.email_work);
        parser.setVariable('isLineManager', selectedItem.is_line_manager);
        parser.setVariable('lineManagerPersNo', selectedItem.line_manager_pers_no);
        parser.setVariable('jobID', selectedItem.job_id);
        parser.setVariable('jobLevel', selectedItem.job_level);
        parser.setVariable('jobName', selectedItem.job_name);
        parser.setVariable('jobProfileID', selectedItem.job_profile_id);
        parser.setVariable('jobSubFamilyName', selectedItem.job_subfamily_name);
        parser.setVariable('positionTitle', selectedItem.position_title);
        parser.setVariable('orgUnit', selectedItem.organization_unit);
        parser.setVariable('orgUnitName', selectedItem.organization_unit_name);
        parser.setVariable('orgUnitObbrev', selectedItem.organization_unit_obbrev);
        parser.setVariable('orgUnitOne', selectedItem.organization_unit_1);
        parser.setVariable('orgUnitOneName', selectedItem.organization_unit_1_name);
        parser.setVariable('orgUnitTwo', selectedItem.organization_unit_2);
        parser.setVariable('orgUnitTwoName', selectedItem.organization_unit_2_name);
        parser.setVariable('orgUnitThree', selectedItem.organization_unit_3);
        parser.setVariable('orgUnitThreeName', selectedItem.organization_unit_3_name);
        parser.setVariable('orgUnitFour', selectedItem.organization_unit_4);
        parser.setVariable('orgUnitFourName', selectedItem.organization_unit_4_name);
        parser.setVariable('requestType', data.request_type);
        parser.setVariable('paymentType', data.request ? data.request.payment_type : data.payment_type);
        parser.setVariable('paymentReason', selectedItem.payment_reason);
        parser.setVariable('promotionJobSubfamilyName', selectedItem.promotion_job_subfamily_name);
        parser.setVariable('promotionJobName', selectedItem.promotion_job_name);
        parser.setVariable('newPositionTitle', selectedItem.new_position_title);

        //Our Talent fields start
        parser.setVariable('currentComboSituation', selectedItem.current_combo_situation);
        parser.setVariable('promoIncreasePctGuidelineMin', selectedItem.promo_increase_pct_guideline_min);
        parser.setVariable('promoIncreasePctGuidelineMax', selectedItem.promo_increase_pct_guideline_max);
        parser.setVariable('promoIncreasePctGuideline', selectedItem.promotional_increase_percentage_guideline);
        //parser.setVariable('newIncentiveScheme', selectedItem.new_incentive_scheme);
        parser.setVariable('offCycleSpending', selectedItem.internalhire_off_cycle_spending);
        parser.setVariable('offCycleSpendingInEUR', selectedItem.internal_hire_off_cycle_spending_euro);
        parser.setVariable('sipCase', selectedItem.sip_case);
        parser.setVariable('CaseOneMaxBudgetcalc', selectedItem.Case_One_Max_Budget_calc);
        parser.setVariable('CaseOneTTCIncreaseMinusMaxBudget', selectedItem.Case_one_TTC_increase_minus_Max_budget);
        parser.setVariable('caseOneBudgetCharge', selectedItem.Case_one_Budget_charge);
        parser.setVariable('caseTwoTIIncrease', selectedItem.Case_two_TI_Increase);
        parser.setVariable('caseTwoPromotionBudget', selectedItem.Case_two_Promotion_Budget);
        parser.setVariable('caseTwoTotalBudget', selectedItem.Case_two_Total_budget);
        parser.setVariable('caseTwoBudgetCharge', selectedItem.Case_two_Budget_charge);
        parser.setVariable('caseThreeTwelveMonthActualIncentiveAmountPaid', selectedItem.case_3_12_month_actual_incentive_amount_fte);
        parser.setVariable('OverrideTransitionAllowanceLocalCurrency', selectedItem.override_transition_allowance_local_currency);
        parser.setVariable('caseThreeTwelveMonthTotalTargetCash', selectedItem.Case_three_twelve_month_Total_Target_Cash);
        parser.setVariable('caseThreeNewTTCGapToTwelveMonthTTC', selectedItem.Case_three_new_TTC_Gap_to_twelve_month_TTC);
        parser.setVariable('caseThreeMaxCappedTransitAllowance', selectedItem.Case_three_Max_capped_transit_allowance);
        parser.setVariable('caseThreeTransitionAllowanceTotal', selectedItem.Case_three_Transition_allowance_total);
        parser.setVariable('caseThreeBudgetCharge', selectedItem.Case_three_Budget_charge);
        parser.setVariable('finalOffCycleBudget', selectedItem.Final_Off_Cycle_Budget);
        parser.setVariable('finalOffCycleBudgetEUR', selectedItem.Final_Off_Cycle_Budget_euro);
        parser.setVariable('maxPromoIncrease', selectedItem.Max_Promotional_Increase);
        parser.setVariable('rrNumber',selectedItem.rr_number);
        parser.setVariable('isSip',selectedItem.is_sip);
        parser.setVariable('sipChange',selectedItem.sip_change);
        parser.setVariable('internalHireIncreaseAmt',selectedItem.internalhire_increase_amount);
        parser.setVariable('internalHireIncreasePerc',selectedItem.internalhire_increase_percentage);
        parser.setVariable('hiringManager',selectedItem.hiring_manager);
        parser.setVariable('transition_allowance',selectedItem.transition_allowance);
        //parser.setVariable('transition_allowance',transition_allowance);
        //Our Talent fields end

        //Custom Functions implementation start
        /* 
        R2 Release - Admin calculations
        To get ITP value from theoretical_itps_tbl based on jobFamily, jobGrade and country
        jobFamily = Pass * for sales and pre-sales for others pass actual job family
        jobGrade = Pass * for sales and pre-sales for others pass actual job grade
        country = Pass * for sales and pre-sales and if country is not USA or Canada 
        */
        parser.setFunction('getITPFromJFAndJGAndCountry', function(params) {
          //console.log('params',params);
          //console.log('selectedItem',selectedItem);
          

          let jobFamily = params[0];
          let jobGrade = params[1];
          let country = params[2];
          //console.log("jf===>", jobFamily);
          //console.log("c===>", country);
          //console.log("jg===>", jobGrade);
          //console.log("ECAP_US===>", selectedItem.ECAP_US);

          let match = '';
          /*  DEM0083082 - Starts   */
          if((selectedItem.country_name === 'USA' || selectedItem.country_name === 'Canada'))
          {
            if(selectedItem.ECAP_US == 'Yes')
            {
              match = itpLookupTable.find(obj => obj.job_family === jobFamily && obj.country === country && obj.job_grade === jobGrade && obj.ECAP_US === 'Yes');
              //console.log("match 425=====>", match);
            }
            else
            {
              match = itpLookupTable.find(obj => obj.job_family === jobFamily && obj.country === country && obj.job_grade === jobGrade && (obj.ECAP_US == null || obj.ECAP_US === 'NULL'));
              //console.log("match 430=====>", match);
            }
          }
          else
          {
            match = itpLookupTable.find(obj => obj.job_family === jobFamily && obj.country === country && obj.job_grade === jobGrade);
            //console.log("match 436=====>", match);
          }
          /*  DEM0083082 - Ends   */
          
          return match ? match.itp : 0;
        });
        
        /* 
        R2 Release - Admin calculations
        To get New Salary Range Min,New Salary Range Mid and New Salary Range Max by country, pay scale area, Pay Grade and currency code
        country = Country Code
        payScaleArea = Pay scale Area
        payGrade = Pay Grade
        currency = currency code
        */
       parser.setFunction('getSalaryRange', function(params) {
        //console.log('params at 396',params);
        let currency = params[3];
        let payGrade = params[2];
        let payScaleArea = params[1];
        let country = params[0];
        let nokia_id = parser.getVariable('nokiaID');
        
        var emp_City = parser.getVariable('Final_City_For_Salary_Range');
        let salaryRangeFound;
        
        /* DEM0079460 - Changes Starts */
        /*const salaryRanges = config.allSalaryRanges
        console.log('salaryRanges',salaryRanges)
        let salaryRangeFound;
        for (const salaryRange of salaryRanges) {
          // eslint-disable-next-line
          if (salaryRange.country_name == country && salaryRange.grade_region == payScaleArea && salaryRange.pay_grade == payGrade && salaryRange.currency_code == currency) {
            salaryRangeFound = salaryRange
            break
          }
        }
        let result = 0;
        switch(params[4]){
          case 'newSrMin':
            result = salaryRangeFound?salaryRangeFound.ttc_salary_range_min:0;
            break;
          case 'newSrMid':
            result = salaryRangeFound?salaryRangeFound.ttc_salary_range_mid:0;
            break;
          case 'newSrMax':
            result = salaryRangeFound?salaryRangeFound.ttc_salary_range_max:0;
            break;
        }*/

        //const config_AssignmentCurrent = config.allORA_CH_EMP_ASSIGNMENT_CURRENT;
        /*const config_AssignmentCurrent_New = config.allORA_CH_EMP_ASSIGNMENT_CURRENT[0].PERSON_NUMBER;
        const config_AssignmentCurrent_New_NokiaIDs = config.allORA_CH_EMP_ASSIGNMENT_CURRENT[0].Assignment_number;
        
        var emp_City = '';
        let salaryRangeFound;
        
        if(country == 'China')
        {
          let PERSONNEL_SUB_AREA_For_CHINA = '';
        
          var split_AssCur_NokiaID = config_AssignmentCurrent_New_NokiaIDs.split("***");
          //var nokiaIDPositionIn_AssCurr = split_AssCur_NokiaID.indexOf(nokia_id);
          var nokiaIDPositionIn_AssCurr = binarySearch(split_AssCur_NokiaID, nokia_id);
          //console.log("NOKIAIDFOUND at===>"+nokiaIDPositionIn_AssCurr);

          //var recordPositionIn_AssCurr = split_AssCur_1.findIndex(item => item.includes("PERSON_NUMBER=>"+nokia_id));
          if(nokiaIDPositionIn_AssCurr > -1)
          {
            var split_AssCur_1 = config_AssignmentCurrent_New.split("***");
            var recordInfoIn_AssCurr = split_AssCur_1[nokiaIDPositionIn_AssCurr];
            //console.log("NOKIA ID DETAILS FOUND===>>>>", recordInfoIn_AssCurr);

            var split_AssCur_2          = recordInfoIn_AssCurr.split('@@@');
            var STR_PERSON_NUMBER       = split_AssCur_2[0].split("=>");
            //var STR_ASSIGN_NUMBER       = split_AssCur_2[1].split("=>");
            //var STR_START_DATE          = split_AssCur_2[2].split("=>");
            //var STR_END_DATE            = split_AssCur_2[3].split("=>");
            var STR_LOCATION_CODE       = split_AssCur_2[4].split("=>");
            var STR_LOCATION_NAME       = split_AssCur_2[5].split("=>");
            var STR_PERSONNEL_SUB_AREA  = split_AssCur_2[6].split("=>");

            PERSONNEL_SUB_AREA_For_CHINA = STR_PERSONNEL_SUB_AREA[1].trim();
          }

          
        //console.log("PERSONNEL_SUB_AREA_For_CHINA===>", PERSONNEL_SUB_AREA_For_CHINA);
          if(PERSONNEL_SUB_AREA_For_CHINA != '' && PERSONNEL_SUB_AREA_For_CHINA != 'null' && PERSONNEL_SUB_AREA_For_CHINA != null)
          {
            var exp_persSubArea = PERSONNEL_SUB_AREA_For_CHINA.split("-");
            emp_City = exp_persSubArea[1].trim();
          }
          else
          {
            emp_City = '';
          }
        }
        else
        {
          var emp_LocationCode = '';
          var emp_LocationName = '';

          var split_AssCur_NokiaID = config_AssignmentCurrent_New_NokiaIDs.split("***");
          //var nokiaIDPositionIn_AssCurr = split_AssCur_NokiaID.indexOf(nokia_id);
          var nokiaIDPositionIn_AssCurr = binarySearch(split_AssCur_NokiaID, nokia_id);
          //console.log("NOKIAIDFOUND at===>"+nokiaIDPositionIn_AssCurr);
          
          if(nokiaIDPositionIn_AssCurr > -1)
          {
            var split_AssCur_1 = config_AssignmentCurrent_New.split("***");
            var recordInfoIn_AssCurr = split_AssCur_1[nokiaIDPositionIn_AssCurr];
            //console.log("NOKIAIDFOUND at===>"+recordPositionIn_AssCurr);
            //console.log("NOKIA ID DETAILS FOUND===>>>>", recordInfoIn_AssCurr);

            var split_AssCur_2          = recordInfoIn_AssCurr.split('@@@');
            var STR_PERSON_NUMBER       = split_AssCur_2[0].split("=>");
            var STR_ASSIGN_NUMBER       = split_AssCur_2[1].split("=>");
            var STR_START_DATE          = split_AssCur_2[2].split("=>");
            var STR_END_DATE            = split_AssCur_2[3].split("=>");
            var STR_LOCATION_CODE       = split_AssCur_2[4].split("=>");
            var STR_LOCATION_NAME       = split_AssCur_2[5].split("=>");
            var STR_PERSONNEL_SUB_AREA  = split_AssCur_2[6].split("=>");

            emp_LocationCode = STR_LOCATION_CODE[1];
            emp_LocationName = STR_LOCATION_NAME[1];
          }
          //console.log(emp_LocationCode+'<========>'+emp_LocationName)
          if(emp_LocationCode != '' && emp_LocationName != '')
          {
            //const config_LocationsAll = config.allORA_F_Locations;
            const config_LocationAll_Codes = config.allORA_F_Locations[0].LOCATION_NAME;
            //console.log(config_LocationAll_Codes);
            var split_Location_Codes = config_LocationAll_Codes.split("***");
            //console.log("LOCATION CODE ARRAY====>",split_Location_Codes);
            //var locationCodePositionIn_Location = split_Location_Codes.indexOf(emp_LocationCode);
            var locationCodePositionIn_Location = binarySearch(split_Location_Codes, emp_LocationCode);
            //console.log("LOCATIONFOUND at===>"+locationCodePositionIn_Location);

            if(locationCodePositionIn_Location > -1)
            {
              const config_LocationAll_New = config.allORA_F_Locations[0].LOCATION_CODE;
              var split_Loc_1 = config_LocationAll_New.split("***");
              var recordInfoIn_Loc = split_Loc_1[locationCodePositionIn_Location];
            
              //console.log("LOCATION DETAILS FOUND===>>>>", recordInfoIn_Loc);

              var split_Loc_2       = recordInfoIn_Loc.split('@@@');
              var STR_LOCATION_CODE = split_Loc_2[0].split("=>");
              var STR_LOCATION_NAME = split_Loc_2[1].split("=>");
              var CITY              = split_Loc_2[2].split("=>");
              emp_City = CITY[1];
            }
          }
          
        }*/
        //console.log("Final Calculated City===>", emp_City);
        let numericGradeNum_Emp = payGrade.match(/\d+/)[0];
        let lastJobFamWrd_Emp = payGrade.slice(-2);
        if(numericGradeNum_Emp.length == 2 && numericGradeNum_Emp[0] == '0')
        numericGradeNum_Emp = numericGradeNum_Emp.replace("0", "");

        let finalGradeNameForComparison  = '';
        if(country == 'USA')
        {
          if(emp_City == 'Sunnyvale' || emp_City == 'Mountain View' || emp_City == 'San Francisco')
          {
            finalGradeNameForComparison = numericGradeNum_Emp+'California'+lastJobFamWrd_Emp;
          }
          else
          {
            finalGradeNameForComparison = numericGradeNum_Emp+'Remainder'+lastJobFamWrd_Emp;
          }
        }
        else if(country == 'China')
        {
          if(emp_City == 'Beijing' || emp_City == 'Shanghai' || emp_City == 'Guangzhou' || emp_City == 'Shenzhen')
          {
            finalGradeNameForComparison = numericGradeNum_Emp+'Beijing_Shanghai'+lastJobFamWrd_Emp;
          }
          else
          {
            finalGradeNameForComparison = numericGradeNum_Emp+'Remainder'+lastJobFamWrd_Emp;
          }
        }
        else if(country == 'Poland')
        {
          if(emp_City == 'Warsaw')
          {
            finalGradeNameForComparison = numericGradeNum_Emp+'Warsaw'+lastJobFamWrd_Emp;
          }
          else
          {
            finalGradeNameForComparison = numericGradeNum_Emp+'Remainder'+lastJobFamWrd_Emp;
          }
        }
        else
        {
          finalGradeNameForComparison = numericGradeNum_Emp+''+lastJobFamWrd_Emp;
        }

        //console.log("finalGradeNameForComparison====>", finalGradeNameForComparison);

        const config_Grade_RatesAll_New = config.allORA_F_Grade_Rates[0].GRADE_RATE_NAME;
        var split_GRD_1 = config_Grade_RatesAll_New.split("***");

        //console.log("split_GRD_1===>", split_GRD_1);
        
        var stringToBeSearch = "GRADE_RATE_NAME=>"+finalGradeNameForComparison+"@@@LDG_Name=>Nokia "+country+" LDG";
        var recordPositionIn_AssCurr = split_GRD_1.findIndex(item => item.includes(stringToBeSearch));
      
        //console.log("GRName FOUND at===>"+recordPositionIn_AssCurr);
        salaryRangeFound = split_GRD_1[recordPositionIn_AssCurr];
        //console.log("Final City Found=====>"+emp_City);
        /*if(emp_City != '')
        {
          //console.log("===>"+emp_LocationCode+"<===="+emp_LocationName+"<===="+emp_City);

          //const config_Grade_RatesAll = config.allORA_F_Grade_Rates;
          const config_Grade_RatesAll_New = config.allORA_F_Grade_Rates[0].GRADE_RATE_NAME;
          var split_GRD_1 = config_Grade_RatesAll_New.split("***");
          const gradeAllLength = split_GRD_1.length;
          for(var incrGRD_1 = 0; incrGRD_1 < gradeAllLength; incrGRD_1++)
          {
            if(split_GRD_1[incrGRD_1] != '')
            {
              //console.log("====&&&&&&&", split_GRD_1[incrGRD_1]);
              var split_GRD_2    = split_GRD_1[incrGRD_1].split('@@@');
              var STR_GRADE_RATE_NAME = split_GRD_2[0].split("=>");
              var STR_LDG_Name        = split_GRD_2[1].split("=>");
              var STR_TTC_Low          = split_GRD_2[2].split("=>");
              var STR_TTC_Mid          = split_GRD_2[3].split("=>");
              var STR_TTC_High          = split_GRD_2[4].split("=>");
              
              let numericGradeNum = STR_GRADE_RATE_NAME[1].match(/\d+/)[0];
              let lastJobFamWrd = STR_GRADE_RATE_NAME[1].slice(-2);
              let restGradeStr = STR_GRADE_RATE_NAME[1].replace(numericGradeNum, "");
              restGradeStr = restGradeStr.replace(lastJobFamWrd, "");

              let numericGradeNum_Emp = payGrade.match(/\d+/)[0];
              let lastJobFamWrd_Emp = payGrade.slice(-2);
              if(numericGradeNum_Emp.length == 2 && numericGradeNum_Emp[0] == '0')
              numericGradeNum_Emp = numericGradeNum_Emp.replace("0", "");

              let finalGradeNameForComparison = numericGradeNum_Emp+restGradeStr+lastJobFamWrd_Emp;
              let cityNameForCompare = '';

              if(country == 'USA')
              {
                if(emp_City == 'Sunnyvale' || emp_City == 'Mountain View' || emp_City == 'San Francisco')
                {
                  finalGradeNameForComparison = numericGradeNum_Emp+'California'+lastJobFamWrd_Emp;
                }
                else
                {
                  finalGradeNameForComparison = numericGradeNum_Emp+'Remainder'+lastJobFamWrd_Emp;
                }
              }
              else if(country == 'China')
              {
                if(emp_City == 'Beijing' || emp_City == 'Shanghai' || emp_City == 'Guangzhou' || emp_City == 'Shenzhen')
                {
                  finalGradeNameForComparison = numericGradeNum_Emp+'Beijing_Shanghai'+lastJobFamWrd_Emp;
                }
                else
                {
                  finalGradeNameForComparison = numericGradeNum_Emp+'Remainder'+lastJobFamWrd_Emp;
                }
              }
              else if(country == 'Poland')
              {
                if(emp_City == 'Warsaw')
                {
                  finalGradeNameForComparison = numericGradeNum_Emp+'Warsaw'+lastJobFamWrd_Emp;
                }
                else
                {
                  finalGradeNameForComparison = numericGradeNum_Emp+'Remainder'+lastJobFamWrd_Emp;
                }
              }
              else
              {
                finalGradeNameForComparison = numericGradeNum_Emp+''+lastJobFamWrd_Emp;
              }

              if (STR_LDG_Name[1] == "Nokia "+country+" LDG" && STR_GRADE_RATE_NAME[1] == finalGradeNameForComparison) 
              {
                salaryRangeFound = split_GRD_1[incrGRD_1];
                //console.log("finalGradeNameForComparison====>", finalGradeNameForComparison);
                break;
              }

            }
          }
        }*/
        let result = 0;
        //console.log("PARAMS_PROCESSED====>", params);
        //console.log("PARAM 4===>", params[4]);
        switch(params[4]){
          case 'newSrMin':
            //result = salaryRangeFound?salaryRangeFound.TTC_Low:0;
            if(salaryRangeFound != '' && salaryRangeFound != undefined)
            {
              var split_Sal_min    = salaryRangeFound.split('@@@');
              var arrGRADE_RATE_NAME = split_Sal_min[0].split("=>");
              var arrLDG_Name        = split_Sal_min[1].split("=>");
              var arrTTC_Low          = split_Sal_min[2].split("=>");
              var arrTTC_Mid          = split_Sal_min[3].split("=>");
              var arrTTC_High          = split_Sal_min[4].split("=>");
            }
            else
            {
              var arrTTC_Low          = new Array('lowVal', 0);
            }
            
            //console.log("calculated final MIN==", arrTTC_Low[1]); 
            result = parseFloat(arrTTC_Low[1]) ? parseFloat(arrTTC_Low[1]) : 0
            break;
          case 'newSrMid':
            //result = salaryRangeFound?salaryRangeFound.TTC_Mid:0;
            if(salaryRangeFound != '' && salaryRangeFound != undefined)
            {
              var split_Sal_mid    = salaryRangeFound.split('@@@');
              var arrGRADE_RATE_NAME = split_Sal_mid[0].split("=>");
              var arrLDG_Name        = split_Sal_mid[1].split("=>");
              var arrTTC_Low          = split_Sal_mid[2].split("=>");
              var arrTTC_Mid          = split_Sal_mid[3].split("=>");
              var arrTTC_High          = split_Sal_mid[4].split("=>");
            }
            else
            {
              var arrTTC_Mid          = new Array('lowVal', 0);
            }
            //console.log("calculated final MID==", arrTTC_Mid[1]); 
            if(document.getElementById("overlay"))
            {
              //document.getElementById("overlay").style.display = 'none';
              //document.getElementById("frmLoader").style.display = 'none';
            }
            result = parseFloat(arrTTC_Mid[1]) ? parseFloat(arrTTC_Mid[1]) : 0
            
            break;
          case 'newSrMax':
            //result = salaryRangeFound?salaryRangeFound.TTC_High:0;
            if(salaryRangeFound != '' && salaryRangeFound != undefined)
            {
              var split_Sal_max    = salaryRangeFound.split('@@@');
              var arrGRADE_RATE_NAME = split_Sal_max[0].split("=>");
              var arrLDG_Name        = split_Sal_max[1].split("=>");
              var arrTTC_Low          = split_Sal_max[2].split("=>");
              var arrTTC_Mid          = split_Sal_max[3].split("=>");
              var arrTTC_High          = split_Sal_max[4].split("=>");
            }
            else
            {
              var arrTTC_High          = new Array('lowVal', 0);
            }
            
            //console.log("calculated final MAX==", arrTTC_High[1]); 
            result = parseFloat(arrTTC_High[1]) ? parseFloat(arrTTC_High[1]) : 0
            break;
        }
        //console.log("returned result from main function====>", result);
        return result; 
        /* DEM0079460 - Changes Ends */
      });
      /*
      *To get gpp_guideline_max value from GPP Lookup Table
      quartile = Quartile
      countryCode = country Code
      */
      parser.setFunction('getGPPLookupTableByQuartileAndCountry', function(params) {
        //console.log('params',params);
        let quartile = params[0];
        let countryCode = params[1];
        if (!selectedItem || !selectedItem.is_gpp_eligible) return 0.00;
        const match = gppLookupTable.find(obj => obj.quartile === quartile && obj.country === countryCode);
        return match ? match.max : 0;
      });
      /**
       * To Get exchange rate based on From and To currency
       * toCurrency = To Currency code
       * fromCurrency = From Currency Code
       */
      parser.setFunction('getExchangeRateByCurrencyCode', function(params) {
        //console.log('params',params);
        let toCurrency = params[1];
        let fromCurrency = params[0];
        if (!selectedItem || !selectedItem.currency) return 1;
        const match = exchangeRates.find(r => r.to_currency === toCurrency && r.from_currency === fromCurrency);
        return match ? match.exchange_rate : 1;
      });

      /**
       * To Get promotion pay grade from job catalog
       */
      parser.setFunction('filteredPromotionPayGrade', function(params) {
        // edit or create
        const activeData = data.request ? data.request : data;
        // console.log('promotion_pay_grade', activeData.promotion_pay_grade)
        // if (activeData.promotion_pay_grade) return activeData.promotion_pay_grade;
        // if (data.request && data.request.promotion_pay_grade) return data.request.promotion_pay_grade;

        let filters = null;
        if (activeData.promotion_job_name) {
          filters = {
            job_family_name: v => v === selectedItem.promotion_job_family_name,
            job_subfamily_name: v => v === selectedItem.promotion_job_subfamily_name,
            job_name: v => v === activeData.promotion_job_name
          };
        }
        if (activeData.promotion_job_subfamily_name) {
          filters = {
            job_family_name: v => v === selectedItem.promotion_job_family_name,
            job_subfamily_name: v => v === activeData.promotion_job_subfamily_name,
            job_name: v => v === selectedItem.promotion_job_name
          };
        }
        if (activeData.promotion_job_family_name) {
          filters = {
            job_family_name: v => v === activeData.promotion_job_family_name,
            job_subfamily_name: v => v === selectedItem.promotion_job_subfamily_name,
            job_name: v => v === selectedItem.promotion_job_name
          };
        }

        if (filters) {
          const filtered = filterJobCatalog(filters, 'pay_grade', config, activeData);
          //const matchingGrade = filtered.find(x => x.startsWith(selectedItem.job_grade));
          //return matchingGrade ? matchingGrade : filtered.shift();
          return filtered.shift();
        }else{
          return null;
        }
      });   
      /**
       * To get JobGrade index from Job Catalog
       * param 1 =  Job Grade value
       *  */  
      parser.setFunction('getJobGradeIndex', function(params) {
        let jobGradeValue = params[0];
        return jobGrades.findIndex(x => x === jobGradeValue);
      });

      //Our Talent custom formulas start
      /**
       * To get Grade progression of a country using country Name
       * param 1 =  Country full name
       *  */  
      parser.setFunction('getCountriesGradeProgressions', function(params) {
        let country = params[0];
        const match = countryLookupTable.find(obj => obj.country === country);
        return match ? match.grade_progression.trim(): "";
      });

      /**
       * To get Increase guidelines using current IP situation
       * param 1 =  min/max string
       * param 2 = current ITP situation 
       *  */  
      parser.setFunction('getIncreaseGuidelines', function(params) {
        let minMax = params[0];
        let currentItpSituation = params[1];

        //console.log(selectedItem, "SELECTED COUNTRY");
        //console.log(currentItpSituation, "CURRENT ITP SITUATION");
        //console.log(increaseLookupTable, "increase Lookup Table");

        var keys = ["combo", 'country'];
        if((selectedItem.country == 'US' || selectedItem.country == 'USA') && selectedItem.country_name == 'USA')
          var values = [currentItpSituation, 'USA'];
        else if((selectedItem.country == 'CA' || selectedItem.country == 'CAN') && selectedItem.country_name == 'Canada')
          var values = [currentItpSituation, 'Canada'];
        else
          var values = [currentItpSituation, '*']; 

        var result = increaseLookupTable.filter(function(e) {
          return keys.every(function(a) {
            return values.includes(e[a])
          })
        })
        //console.log(result, "resultresultresultresultresultresultresultresultresultresult")
        var returnedVal = '';
        if(minMax == 'min')
        {
          returnedVal = result[0].min;
        }
        else if(minMax == 'max')
        {
          returnedVal = result[0].max;
        }
        return returnedVal;
        //const match = '';
        //return match ? minMax=='min'?result.min : minMax=='max'?result.max : 0 : 0;

        //const match = increaseLookupTable.find(obj => obj.combo === currentItpSituation);
        //return match ? minMax=='min'?match.min : minMax=='max'?match.max : 0 : 0;
      });
      //Our Talent custom formulas end

      //To check not a number
      parser.setFunction('isNaN', isNaN);
      
    }

    /*
    R2 - Admin Calculations
    getRequiredFormula() - Get required Formula from list of formulas available in DB
    */
    const getRequiredFormula = (formulaNeeded) => {
        let formulaFound = null;
        Object.values(formulas.formulas).forEach((fr, indx) => {
            if (fr.formula_name == formulaNeeded) {
                formulaFound = fr.formula;
            }
        });
        return formulaFound;
    }
    

  /*  DEFECTS FIX STARTS  */
  const ttc_increase = useMemo(
    () =>
      selectedItem
        ? ((selectedItem.new_fte_ttc_annual_salary) - (selectedItem.fte_ttc_annual_salary))
        : 0,
    [selectedItem]
  );
  //phase2 
  const ttc_increase_perc = useMemo(
    () => {
      if (!selectedItem) {
        return 0;
      }

      /*
      * Use the directly supplied TTC increase percentage
      * when it contains a non-zero value.
      */
      if (
        data.ttc_increase_percentage !== undefined &&
        data.ttc_increase_percentage !== null &&
        data.ttc_increase_percentage !== ""
      ) {
        const percentage = Number(data.ttc_increase_percentage);

        if (!Number.isNaN(percentage) && percentage !== 0) {
          return percentage;
        }
      }

      if (
        data.request &&
        data.request.ttc_increase_percentage !== undefined &&
        data.request.ttc_increase_percentage !== null &&
        data.request.ttc_increase_percentage !== ""
      ) {
        const percentage =
          Number(data.request.ttc_increase_percentage);

        if (!Number.isNaN(percentage) && percentage !== 0) {
          return percentage;
        }
      }

      /*
      * Promotion / other calculated scenarios:
      * derive TTC increase percentage from
      * Current TTC -> New TTC.
      */
      const currentTtc =
        Number(selectedItem.fte_ttc_annual_salary) || 0;

      const newTtc =
        Number(selectedItem.new_fte_ttc_annual_salary) || 0;

      if (currentTtc === 0) {
        return 0;
      }

      return round(
        ((newTtc - currentTtc) / currentTtc) * 100,
        10
      );
    },
    [selectedItem, data]
  );

  const transition_allowance = useMemo(
    () => {
      if (!selectedItem) return 0;

      const new_fte_ttc_annual_salary =
        Number(selectedItem.new_fte_ttc_annual_salary) || 0;

      const sum_of_pay_amount = Number(selectedItem.sum_of_pay_amount) || 0;

      //return round(new_fte_ttc_annual_salary - sum_of_pay_amount, 3);

      return round(sum_of_pay_amount - new_fte_ttc_annual_salary, 3);
    },
    [selectedItem]
  );

  const total_increaseed_amount = useMemo(
    () =>
      selectedItem
        ? ((selectedItem.new_fte_ttc_annual_salary) - (selectedItem.fte_ttc_annual_salary))
        : 0,
    [selectedItem]
  );
  /*  DEFECTS FIX ENDS  */
  
  const exchange_rate = useMemo(
    () => {
      if (!selectedItem || !selectedItem.currency) return 1;
      //getExchangeRateByCurrencyCode('EUR',localCurrencyCode)
      // console.log('localCurrencyCode',parser.getVariable('localCurrencyCode'));
      // console.log('selectedItem.currency',selectedItem.currency)
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Exchange Rate');
      //(1-currency/currentSrMid)+(currentSrMax/currentSrMid-1)
      let res = parser.parse(formulaToParse);
      //console.log('parsed exchange rate', res);
      return res.result;
      // const { exchangeRates } = config;
      // if (!selectedItem || !selectedItem.currency) return 1;
      // const match = exchangeRates.find(r => r.to_currency === selectedItem.currency && r.from_currency === 'EUR');
      // return match ? 1 / match.exchange_rate : 1;
    },
    [selectedItem, config]
  );

  const salary_range_spread = useMemo(
    () => {
      if (!selectedItem) return 0;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Range Spread');
      //(1-currency/currentSrMid)+(currentSrMax/currentSrMid-1)
      let res = parser.parse(formulaToParse);
      return res.result;     
      //return (1 - selectedItem.salary_range_min / selectedItem.salary_range_mid) + (selectedItem.salary_range_max / selectedItem.salary_range_mid - 1);
    },
    [selectedItem]
  );

  const tenure = useMemo(
    () => {
      if (selectedItem) {
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Tenure');
        let res = parser.parse(formulaToParse);
        //(CURRENT_TIMESTAMP-IF(dateOfJoining<>null,dateOfJoining,CURRENT_TIMESTAMP))/86400000/365
        // console.log('CURRENT_TIMESTAMP',parser.getVariable('CURRENT_TIMESTAMP'))
        // console.log('dateOfJoining', parser.getVariable('dateOfJoining'))
        //console.log('parsed Tenure', res)
        return res.result;
      } else {
        return 0;
      }
      // if(selectedItem){
      // console.log('CURRENT_TIMESTAMP',CURRENT_TIMESTAMP)
      // console.log('selectedItem.pers_start_date',selectedItem.pers_start_date)
      // return selectedItem ? (CURRENT_TIMESTAMP - (selectedItem.pers_start_date || CURRENT_TIMESTAMP)) / 86400000 / 365 : 0 
      // }
    },
    [selectedItem]
  );
  
  const is_gpp_eligible = useMemo(
    () =>{
      if(selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('GPP Validation');
        //console.log('GPP Validation to parse ',formulaToParse);
        //AND(currentJobGrade=06,interimJobGrade=07,tenure>=1.5, tenure<=4)
        // console.log('currentJobGrade',parser.parse('currentJobGrade'))
        // console.log('interimJobGrade',parser.parse('interimJobGrade'))
        // console.log('tenure',parser.parse('tenure'))
        let res = parser.parse(formulaToParse);
        //console.log('result for GPP Validation is',res)
        return res.result;
      }else{
          return false;
      }
    },
    [selectedItem]
  );

  const ttc_increase_amount = useMemo(
    () => {

      if (!selectedItem) {
        return 0;
      }

      /** Release 2 - OurTalent making TTC increase amount calculated at some scenario - Starts */

      if (data.request_type === "compensation") {

        const checkbox = document.querySelector(
          'input[name="change_pay_mix"]'
        );

        if (checkbox && checkbox.checked) {

          /*
          * Change Pay Mix:
          *
          * New ABS = user input
          * New ITA = existing/user value
          * TTC Increase = New ABS + New ITA - Current TTC
          *
          * IMPORTANT:
          * Do NOT use ttc_increase_percentage here.
          * TTC Amount is the source for Change Pay Mix.
          */

          let newFteAnnualSalary;

          if (
            data.new_fte_annual_salary !== undefined &&
            data.new_fte_annual_salary !== null &&
            data.new_fte_annual_salary !== ""
          ) {

            newFteAnnualSalary =
              Number(data.new_fte_annual_salary) || 0;

          } else if (
            data.request &&
            data.request.new_fte_annual_salary !== undefined &&
            data.request.new_fte_annual_salary !== null &&
            data.request.new_fte_annual_salary !== ""
          ) {

            newFteAnnualSalary =
              Number(data.request.new_fte_annual_salary) || 0;

          } else {

            newFteAnnualSalary =
              Number(selectedItem.new_fte_annual_salary) || 0;
          }

          const newFteIncentiveTargetAmount =
            Number(selectedItem.new_fte_incentive_target_amount) || 0;

          const currentFteTtcAnnualSalary =
            Number(selectedItem.fte_ttc_annual_salary) || 0;

          const calculatedAmount =
            newFteAnnualSalary +
            newFteIncentiveTargetAmount -
            currentFteTtcAnnualSalary;

          return Number(calculatedAmount.toFixed(3));
        }
      }

      /** Release 2 - Ends */


      /* Release 3.2 - 19.1 Starts */

      if (data.ttc_increase_amount !== undefined) {

        const v = isNaN(data.ttc_increase_amount)
          ? 0
          : data.ttc_increase_amount;

        if (
          data.request_type === "internalhire" &&
          selectedItem.incentive_plan_type === "YLIP"
        ) {
          selectedItem.sip_change = false;
        }

        return Math.abs(v);
      }

      if (
        data.request &&
        data.request.ttc_increase_amount !== undefined
      ) {

        const v = isNaN(data.request.ttc_increase_amount)
          ? 0
          : data.request.ttc_increase_amount;

        if (
          data.request_type === "internalhire" &&
          selectedItem.incentive_plan_type === "YLIP"
        ) {
          selectedItem.sip_change = false;
        }

        return Math.abs(v);
      }

      /* Release 3.2 - 19.1 Ends */


      if (selectedItem.sip_change) {

        return (
          selectedItem.new_fte_annual_salary &&
          selectedItem.new_fte_incentive_target_amount &&
          (
            selectedItem.new_fte_annual_salary +
            selectedItem.new_fte_incentive_target_amount
          ) >= 0
        )
          ? (
              selectedItem.new_fte_annual_salary +
              selectedItem.new_fte_incentive_target_amount
            ) -
            selectedItem.fte_ttc_annual_salary
          : 0;
      }


      /*
      * NORMAL MERIT / PROMOTION
      *
      * KEEP THE ORIGINAL FORMULA.
      *
      * The formula uses ttc_increase_pct.
      * ttc_increase_pct must therefore be an INPUT/source value,
      * not calculated from ttc_increase_amount.
      */

      defineFormulaVars();

      if (data.request_type === "compensation") {
        const currentTtcIncreasePercentage =
          data.ttc_increase_percentage !== undefined
            ? data.ttc_increase_percentage
            : (
                data.request &&
                data.request.ttc_increase_percentage !== undefined
              )
              ? data.request.ttc_increase_percentage
              : selectedItem.ttc_increase_percentage;

        parser.setVariable(
          'ttc_increase_pct',
          Number(currentTtcIncreasePercentage) || 0
        );

        parser.setVariable(
          'TTCIncreasePercentage',
          Number(currentTtcIncreasePercentage) || 0
        );
      }

      let formulaToParse =
        getRequiredFormula('Merit/Promotion TTC Increase');

      let res = parser.parse(formulaToParse);

      console.log(
        'result Merit/Promotion TTC Increase',
        res
      );

      return res.result;

    },
    [selectedItem, data]
  );

  const ttc_increase_percentage = useMemo(
    () => {

      if (!selectedItem) {
        return 0;
      }

      /* Release 3.2 - 19.1 Starts */

      /*
      * TTC INCREASE AMOUNT -> TTC INCREASE PERCENTAGE
      *
      * When Amount is the current input/source,
      * calculate Percentage from Amount.
      */
      if (data.ttc_increase_amount !== undefined) {

        const currentTtc =
          Number(selectedItem.fte_ttc_annual_salary) || 0;

        const amount =
          Number(data.ttc_increase_amount) || 0;

        if (currentTtc === 0) {
          return 0;
        }

        return round(
          (amount / currentTtc) * 100,
          10
        );
      }

      /*
      * If amount is supplied inside request,
      * calculate Percentage from Amount.
      */
      if (
        data.request &&
        data.request.ttc_increase_amount !== undefined
      ) {

        const currentTtc =
          Number(selectedItem.fte_ttc_annual_salary) || 0;

        const amount =
          Number(data.request.ttc_increase_amount) || 0;

        if (currentTtc === 0) {
          return 0;
        }

        return round(
          (amount / currentTtc) * 100,
          10
        );
      }

      /*
      * TTC INCREASE PERCENTAGE is the current source.
      *
      * Keep the existing Percentage -> Amount behavior.
      */
      if (data.ttc_increase_percentage !== undefined) {

        if (
          data.request_type === "internalhire" &&
          selectedItem.incentive_plan_type === "YLIP"
        ) {
          selectedItem.sip_change = false;
        }

        return Math.abs(data.ttc_increase_percentage);
      }

      if (
        data.request &&
        data.request.ttc_increase_percentage !== undefined
      ) {

        if (
          data.request_type === "internalhire" &&
          selectedItem.incentive_plan_type === "YLIP"
        ) {
          selectedItem.sip_change = false;
        }

        return Math.abs(data.request.ttc_increase_percentage);
      }

      /* Release 3.2 - 19.1 Ends */


      /*
      * CHANGE PAY MIX / SIP CHANGE
      *
      * Existing logic remains unchanged.
      */
      if (
        selectedItem.sip_change ||
        (
          data.request_type === "compensation" &&
          (() => {
            const checkbox = document.querySelector(
              'input[name="change_pay_mix"]'
            );

            return checkbox && checkbox.checked;
          })()
        )
      ) {

        const currentTtc =
          Number(selectedItem.fte_ttc_annual_salary) || 0;

        const amount =
          Number(selectedItem.ttc_increase_amount) || 0;

        if (currentTtc === 0) {
          return 0;
        }

        return round(
          (amount / currentTtc) * 100,
          10
        );
      }


      /*
      * NORMAL MERIT / PROMOTION
      *
      * Percentage remains the source.
      */
      return Number(
        selectedItem.ttc_increase_percentage
      ) || 0;

    },
    [selectedItem, data]
  );

  const override_fte_incentive_target_percentage = useMemo(
    () => {
      if (selectedItem && selectedItem.override_fte_annual_salary) {
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Override Incentive Target Percentage');
        //IF(overrideFteAbs > 0, (overrideFteIta/overrideFteAbs)*100, 0)
        let res = parser.parse(formulaToParse);
        //console.log('parsed override_fte_incentive_target_percentage', res);
        return res.result;
      } else {
        return 0;
      }
    },
    [selectedItem]
  );

  /* Release 2.0 Admin calculation - changing this dynamic */
  const override_fte_ttc_annual_salary = useMemo(
    () => {
      if (selectedItem) {
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Override Total Target Cash (Full-Time Equivalent)');
        //overrideFteAbs+overrideFteIta+additionalFteAnnualPayment
        // console.log('overrideFteAbs',parser.getVariable('overrideFteAbs'))
        // console.log('overrideFteIta',parser.getVariable('overrideFteIta'))
        // console.log('additionalFteAnnualPayment',parser.getVariable('additionalFteAnnualPayment'))
        let res = parser.parse(formulaToParse);
        //console.log('parsed', res);
        return res.result;
      } else {
        return 0;
      }
    },
    [selectedItem]
  );

  const gpp_increase_amount = useMemo(
    () => {
      if (data.gpp_increase_amount) return data.gpp_increase_amount;

      return selectedItem
        ? selectedItem.fte_ttc_annual_salary * (selectedItem.gpp_increase_percentage / 100)
        : null;
    },
    [selectedItem, data]
  );

  const gpp_increase_percentage = useMemo(
    () => {
      if (data.gpp_increase_percentage) return data.gpp_increase_percentage;

      if(selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('GPP Increase Percentage');
        // console.log('formulaToParse',formulaToParse);
        // console.log('lumpSumTwo',parser.getVariable('lumpSumTwo'))
        // console.log('curSalary',parser.getVariable('curSalary'))
        //((lumpSumTwo/curSalary)*100)
        let res = parser.parse(formulaToParse);
        //console.log('Parsed Gpp Increatse perc',res)
        return res.result;
      }else{
        return null;
      }
    },
    [selectedItem, data]
  );

  const promotion_job_family_name = useMemo(
    () => {
      // edit or create
      const activeData = data.request ? data.request : data;
      //console.log(data);

      if (activeData.promotion_job_family_name) return activeData.promotion_job_family_name;

      return selectedItem
        ? selectedItem.promotion_job_family_name || selectedItem.job_family_name
        : null;
    },
    [selectedItem, data]
  );

  const new_position_title = useMemo(
    () => {
      // edit or create
      const activeData = data.request ? data.request : data;

      if (activeData.new_position_title) return activeData.new_position_title;

      return selectedItem
        ? selectedItem.new_position_title || selectedItem.position_title
        : null;
    },
    [selectedItem, data]
  );

  const promotion_job_subfamily_name = useMemo(
    () => {
      // edit or create
      const activeData = data.request ? data.request : data;

      if (activeData.promotion_job_subfamily_name) return activeData.promotion_job_subfamily_name;

      // const f = buildFilters('job_subfamily_name', activeData, selectedItem);
      // console.log(f)

      let filters = null;
      if (activeData.promotion_job_family_name) {
        filters = { job_family_name: v => v === activeData.promotion_job_family_name };
      }

      if (filters) {
        const filtered = filterJobCatalog(filters, 'job_subfamily_name', config, activeData);
        return filtered.shift();
      }

      return selectedItem
        ? selectedItem.promotion_job_subfamily_name || selectedItem.job_subfamily_name
        : null;
    },
    [selectedItem, data, config]
  );
  const promotion_job_name = useMemo(
    () => {
      const { jobsCatalog } = config;
      // edit or create
      const activeData = data.request ? data.request : data;
      // changed - Job Role Name
      if (activeData.promotion_job_name) return activeData.promotion_job_name;

      let filters = null;
      if (activeData.promotion_job_subfamily_name) {
        filters = {
          job_family_name: v => v === selectedItem.promotion_job_family_name,
          job_subfamily_name: v => v === activeData.promotion_job_subfamily_name
        };
      }
      if (activeData.promotion_job_family_name) {
        filters = {
          job_family_name: v => v === activeData.promotion_job_family_name,
          job_subfamily_name: v => v === selectedItem.promotion_job_subfamily_name
        };
      }

      if (filters) {
        const filtered = filterJobCatalog(filters, 'job_name', config, activeData);
        // Return job title which matches current job grade, if possible for given job selection
        const namesAndGrades = jobsCatalog.filter(j => filtered.includes(j.job_name));
        const matching = namesAndGrades.find(jx => jx.pay_grade.startsWith(selectedItem.job_grade));
        return matching ? filtered.find(x => x === matching.job_name) : filtered.shift();
      }
      // changed - Something else or Nothing
      return selectedItem
        ? selectedItem.promotion_job_name || selectedItem.job_name
        : null;
    },
    [selectedItem, data, config]
  );

  const promotion_pay_grade = useMemo(
    () => {
      //interimJobGrade&IF(interimJobFamily="Sales","SA",IF(interimJobFamily="Pre-Sales","PS","HR"))

     //IF(filteredPromotionPayGrade()<>null,filteredPromotionPayGrade(),IF(newPayGrade<>null,newPayGrade,currentPayGrade))
     if (!selectedItem) return null;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('New PayGrade');
      // console.log('filteredPromotionPayGrade()',parser.parse('filteredPromotionPayGrade()'))
      // console.log('currentPayGrade',parser.parse('currentPayGrade'))
      // console.log('newPayGrade',parser.parse('newPayGrade'))
      let res = parser.parse(formulaToParse);
      //console.log('parsed New PayGrade',res)
      return res.result;
      
    },
    [selectedItem, data, config]
  );

  const promotion_job_grade = useMemo(
    () => {
      // edit or create
      const activeData = data.request ? data.request : data;

      if (activeData.promotion_job_grade) return activeData.promotion_job_grade;

      let filters = null;
      if (activeData.promotion_pay_grade) {
        filters = {
          job_family_name: v => v === selectedItem.promotion_job_family_name,
          job_subfamily_name: v => v === selectedItem.promotion_job_subfamily_name,
          job_name: v => v === selectedItem.promotion_job_name,
          pay_grade: v => v === activeData.promotion_pay_grade
        };
      }
      if (activeData.promotion_job_name) {
        filters = {
          job_family_name: v => v === selectedItem.promotion_job_family_name,
          job_subfamily_name: v => v === selectedItem.promotion_job_subfamily_name,
          job_name: v => v === activeData.promotion_job_name,
          pay_grade: v => v === selectedItem.promotion_pay_grade
        };
      }
      if (activeData.promotion_job_subfamily_name) {
        filters = {
          job_family_name: v => v === selectedItem.promotion_job_family_name,
          job_subfamily_name: v => v === activeData.promotion_job_subfamily_name,
          job_name: v => v === selectedItem.promotion_job_name,
          pay_grade: v => v === selectedItem.promotion_pay_grade
        };
      }
      if (activeData.promotion_job_family_name) {
        filters = {
          job_family_name: v => v === activeData.promotion_job_family_name,
          job_subfamily_name: v => v === selectedItem.promotion_job_subfamily_name,
          job_name: v => v === selectedItem.promotion_job_name,
          pay_grade: v => v === selectedItem.promotion_pay_grade
        };
      }

      if (filters) {
        const filtered = filterJobCatalog(filters, 'job_grade', config, activeData);
        return filtered.shift();
      }

      return selectedItem
        ? selectedItem.promotion_job_grade || selectedItem.job_grade
        : null;
    },
    [selectedItem, data, config]
  );
    
  const gpp_guideline_max = useMemo(
    () => {
      if (!selectedItem || !selectedItem.is_gpp_eligible) return 0.00;
      //getGPPLookupTableByQuartileAndCountry(currentQuartile,currentCountryCode)
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('GPP Guidelines Max');
      // console.log('currentQuartile',parser.getVariable('currentQuartile'))
      // console.log('currentCountryCode',parser.getVariable('currentCountryCode'))
      // console.log('selectedItem.ttc_employee_quartile',selectedItem.ttc_employee_quartile)
      // console.log('selectedItem.country',selectedItem.country)
      let res = parser.parse(formulaToParse);
      //console.log('parsed GPP Guidelines Max',res)
      return res.result;
    },
    [selectedItem, config]
  );

  const promoted = useMemo(
    () => {
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Promoted');
            let res = parser.parse(formulaToParse);
            // console.log('finalJobFamily',parser.getVariable('finalJobFamily'))
            // console.log('newJobGrade',parser.getVariable('newJobGrade'))
            // console.log('currentJobGrade',parser.getVariable('currentJobGrade'))
            //console.log('parsed promoted',res)
            return res.result;
        }else{
            return false;
        }
    },
    [selectedItem, config]
  );

  const demoted = useMemo(
    () => {
      if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Demoted');
            let res = parser.parse(formulaToParse);
            //console.log('demoted',res)
            return res.result;
       
      }else{
        return false;
      }
    },
    [selectedItem, config]
  );

  const promotion_job_grade_delta = useMemo(
    () =>{
      if(selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Promotion Job Grade Delta');
        //IF(newJobGrade-currentJobGrade,(newJobGrade-currentJobGrade),"null")
        let res = parser.parse(formulaToParse);
        //console.log('Promotion Job Grade Delta',res)
        return (res.result=="null"||res.result==null)?null:(res.result).toString();
      }else{
        return null;
      }
    },
    [selectedItem]
  );

  const promotion_incentive_target_percentage = useMemo(
    () => {
      
      /**Release 2 Issue check - starts */
      if (!selectedItem) return 0.00;
      /**Release 2 issye check - ends */
      //IF(OR(promoted<>0,promoted<>"",promoted<>null),getITPFromJFAndJGAndCountry(IF(OR(interimJobFamily="Sales", interimJobFamily="Pre-Sales")=false,"*",interimJobFamily),IF(OR(interimJobFamily="Sales", interimJobFamily="Pre-Sales")=true,"*",interimJobGrade),IF(OR(OR(country="USA",country="Canada")=false,AND(OR(interimJobFamily="Sales", interimJobFamily="Pre-Sales")=false,country<>"USA")=true),"*",country)),0.00)
      defineFormulaVars(); //refresh the values of formula variables
      // console.log('promoted',parser.getVariable('promoted'))
      // console.log('interimJobFamily',parser.getVariable('interimJobFamily'))
      // console.log('interimJobGrade',parser.getVariable('interimJobGrade'))
      // console.log('country',parser.getVariable('country'))
      // console.log('part parsed',parser.parse('getITPFromJFAndJGAndCountry(IF(OR(interimJobFamily="Sales", interimJobFamily="Pre-Sales")=false,"*",interimJobFamily),IF(OR(interimJobFamily="Sales", interimJobFamily="Pre-Sales")=true,"*",interimJobGrade),IF(OR(OR(country="USA",country="Canada")=false,AND(OR(interimJobFamily="Sales", interimJobFamily="Pre-Sales")=false,country<>"USA")=true),"*",country))'))
      let formulaToParse = getRequiredFormula('New Theo ITP');
      
      let res = parser.parse(formulaToParse);
      //console.log('parsed promotion_incentive_target_percentage',res);
      return res.result;
    },
    [selectedItem, config]
  );

  const mandatory_ttc_increase_percentage = useMemo(
    () => {
      if (!selectedItem) return 0;
      
      if (!selectedItem.override_promotion_increase){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Mandatory TTC Increase % due to promotion');
        let res = parser.parse(formulaToParse);
        //console.log('parsed Mandatory TTC Increase % due to promotion',res)
        return res.result;
      }
      return 0;
    },
    [selectedItem]
  );

  const mandatory_ttc_increase_amount = useMemo(
    () =>
    {
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Mandatory TTC Increase due to promotion');
            //console.log('formulaToParse',formulaToParse)
            //formulaToParse = 'ROUND(currentFteAbs*(mandatoryTtcIncreasePercentageDueToPromotion/100),2)';
            let res = parser.parse(formulaToParse);
            return res.result;
        }else{
            return 0;
        }
    },
    
    [selectedItem]
  );

  const apply_ti_harmonization = useMemo(
    () => {
      if (!selectedItem) return false;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Apply TI Harmonization?');
      let res = parser.parse(formulaToParse);
      return res.result;
    },
    [selectedItem]
  );

  const interim_harmonization_type = useMemo(
    () => {

        if (selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Harmonization Type');
            let res = parser.parse(formulaToParse);
            return res.result;
        }else{
            return 'No TIH';
        }
    },
    [selectedItem]
  );

  const interim_job_family_name = useMemo(
    () =>
    {
        if (selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Interim Job Family');
            let res = parser.parse(formulaToParse);
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const interim_job_grade = useMemo(
    () =>
    {
        if (selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Interim Job Grade');
            let res = parser.parse(formulaToParse);
            //console.log('parsed interim job grade interim_job_grade', res)
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const interim_pay_grade = useMemo(
    () => {
      if(!selectedItem) return 0;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Interim Pay Grade');
      //console.log('newPayGrade',parser.getVariable('newPayGrade'))
      let res = parser.parse(formulaToParse);
      //console.log('parsed Interim Pay Grade', res)
      return res.result;
    },
    [selectedItem]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const get_salary_range = (country, payScaleArea, payGrade, currency) => {
    const salaryRanges = config.allSalaryRanges
    let salaryRangeFound;
    for (const salaryRange of salaryRanges) {
      // eslint-disable-next-line
      if (salaryRange.country_name == country && salaryRange.grade_region == payScaleArea && salaryRange.pay_grade == payGrade && salaryRange.currency_code == currency) {
        salaryRangeFound = salaryRange
        break
      }
    }
    return salaryRangeFound
  }

  const interim_salary_range_min = useMemo(
    () => {
      // console.log('interim_salary_range_min' , selectedItem, selectedItem && selectedItem.interim_pay_grade)
      if (!selectedItem || !selectedItem.interim_pay_grade) return 0;

      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('New Salary Range Min');
      //console.log("formulaToParse===>", formulaToParse);
      let res = parser.parse(formulaToParse);
      //console.log('parsed New Salary Range Min', res)
      //console.log("hkhkhkhkhkhkhkh====>", res);
      return res.result;
    },
    [selectedItem, get_salary_range]
  );

  const interim_salary_range_mid = useMemo(
    () => {
      if (!selectedItem || !selectedItem.interim_pay_grade) return 0;

      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('New Salary Range Mid');
      let res = parser.parse(formulaToParse);
      //console.log('parsed New Salary Range Mid', res)
      return res.result;
    },
    [selectedItem, get_salary_range]
  );

  const interim_salary_range_max = useMemo(
    () => {
      if (!selectedItem || !selectedItem.interim_pay_grade) return 0;

      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('New Salary Range Max');
      let res = parser.parse(formulaToParse);
      //console.log('parsed New Salary Range Max', res)
      return res.result;
    },
    [selectedItem, get_salary_range]
  );

  const interim_salary_range_spread = useMemo(
    () => {
      if (!selectedItem) return 0;
      if(!selectedItem.interim_salary_range_mid) return 0;
      //(1-newSrMin/newSrMid)+(newSrMax/newSrMid-1)
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('New Salary Range Spread');
      let res = parser.parse(formulaToParse);
      //console.log('parsed New Salary Range Spread', res)
      return res.result;
    },
    [selectedItem]
  );

  const interim_fte_incentive_target_amount = useMemo(
    () => {
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Interim ITA');
            let res = parser.parse(formulaToParse);
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const interim_incentive_target_percentage = useMemo(
    () => {
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Interim ITP');
            let res = parser.parse(formulaToParse);
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const interim_total_increase_amount = useMemo(
    () => {
      if (selectedItem) {
        defineFormulaVars();

        /*
        * Compensation:
        * Use the CURRENT TTC increase amount calculated from
        * the current user-entered TTC increase percentage.
        */
        if (data.request_type === "compensation") {
          parser.setVariable(
            'merit',
            Number(ttc_increase_amount) || 0
          );
        }

        let formulaToParse =
          getRequiredFormula('Total Increase Amount');

        let res = parser.parse(formulaToParse);

        return res.result;
      } else {
        return 0;
      }
    },
    [selectedItem, data, ttc_increase_amount]
  );

  const interim_increase_amount_for_salincr = useMemo(
    () =>{
      
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Step 1 Increase (@ current paymix)');
            let res = parser.parse(formulaToParse);
            //console.log('parsed Step 1 Increase (@ current paymix) interim_increase_amount_for_salincr', res)
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const interim_increase_amount_for_tih = useMemo(
    () =>{
      
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Step 2 Increase (TIH applied)');
            //console.log('overrideTiHarmonization',parser.getVariable('overrideTiHarmonization'));
            //console.log('totalIncreaseAmount',parser.getVariable('totalIncreaseAmount')); 
            let res = parser.parse(formulaToParse);
            //console.log('parsed Step 2 Increase (TIH applied) interim_increase_amount_for_tih', res)
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const step_1_abs = useMemo(
    () =>{
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('Step 1 ABS');
            let res = parser.parse(formulaToParse);
            //console.log('parsed Step 1 ABS', res)
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const step_1_ita = useMemo(
    () =>{
      if(selectedItem){
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Step 1 ITA');
          let res = parser.parse(formulaToParse);
          return res.result;
      }else{
          return 0;
      }
    },
    [selectedItem]
  );

  const step_1_itp = useMemo(
    () =>{
        if(selectedItem){
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Step 1 ITP');
          let res = parser.parse(formulaToParse);
          return res.result;
        }else{
            return 0;
        }
      
    },
    [selectedItem]
  );

  const interim_theo_itp = useMemo(
    () => {
      if (!selectedItem) return 0.00;
     if(selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Interim Theo ITP');
        let res = parser.parse(formulaToParse);
        //console.log('parsed Interim theo ITP', res)
        return res.result;
      }else{
          return 0;
      }      
    },
    [selectedItem, config]
  );

  const interim_itp_situation = useMemo(
    () =>{
      if(selectedItem){
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Interim ITP Situation');
          let res = parser.parse(formulaToParse);
          return res.result;
      }else{
          return 'Norm';
      }
    },
    [selectedItem]
  );

  const step_2_abs_gap = useMemo(
    () => {
      if (!selectedItem) return 0;
      if (!selectedItem.apply_ti_harmonization) return 0;
      if (selectedItem.interim_itp_situation !== 'High') return 0;
      if (!selectedItem.interim_theo_itp) return 0;
      //IF(applyTiHarmonization=false,0,IF(interimItpSituation<>"High",0,IF(interimTheoItp=false,0,(stepOneIta/(interimTheoItp/100))-stepOneAbs)))
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Step 2 ABS Gap');
      //('applyTiHarmonization',parser.getVariable('applyTiHarmonization'))
      //console.log('interimItpSituation',parser.getVariable('interimItpSituation'))
      //console.log('interimTheoItp',parser.getVariable('interimTheoItp'))
      //console.log('stepOneIta',parser.getVariable('stepOneIta'))
      //console.log('stepOneAbs',parser.getVariable('stepOneAbs'))
      let res = parser.parse(formulaToParse);
      //console.log('parsed step_2_abs_gap', res)
      return res.result;
    },
    [selectedItem]
  );

  const step_2_ita_gap = useMemo(
    () => {
      if (!selectedItem) return 0;
      //IF(applyTiHarmonization=false,0,IF(interimItpSituation<>"Low",0,IF(interimTheoItp=false,0,(stepOneAbs*(interimTheoItp/100))-stepOneIta)))
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Step 2 ITA Gap');
      let res = parser.parse(formulaToParse);
      //console.log('parsed step 3 ITA Gap', res)
      return res.result;
    },
    [selectedItem]
  );

  const interim_remainder_for_split = useMemo(
    () => {
      if (!selectedItem) return 0;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Remainder for Split Situation');
      //IF(applyTiHarmonization=false,increaseAmountForTih,IF(OR(AND(stepTwoAbsGap>0,increaseAmountForTih>stepTwoAbsGap),AND(stepTwoItaGap>0,increaseAmountForTih>stepTwoItaGap),AND(stepTwoAbsGap=0,stepTwoItaGap=0)), increaseAmountForTih-stepTwoItaGap-stepTwoAbsGap, 0  ))
      //console.log('applyTiHarmonization',parser.getVariable('applyTiHarmonization'))
      //console.log('increaseAmountForTih',parser.getVariable('increaseAmountForTih'))
      //console.log('stepTwoAbsGap',parser.getVariable('stepTwoAbsGap'))
      //console.log('stepTwoItaGap',parser.getVariable('stepTwoItaGap'))
      let res = parser.parse(formulaToParse);
      //console.log('parsed interim_remainder_for_split', res)
      return res.result;
    },
    [selectedItem]
  );

  const new_fte_annual_salary = useMemo(
    () => {
      if (!selectedItem) return 0;
      
      /*
      * ============================================================
      * Override Manager Proposal - CHECKED
      * ============================================================
      */
      if (selectedItem.override_manager_proposal) {
        const value = selectedItem.override_fte_annual_salary ?? selectedItem.new_fte_annual_salary ?? 0;

        return hasNoDecimals ? round(Number(value), 0) : Number(value);
      }

      /*
      * ============================================================
      * Override Manager Proposal - JUST UNCHECKED
      *
      * Restore the value that existed before Override was checked.
      *
      * IMPORTANT:
      * previousOverride must be TRUE here.
      *
      * Otherwise the snapshot would keep overriding the
      * normal New ABS calculation forever.
      * ============================================================
      */
      if (
        !selectedItem.override_manager_proposal &&
        overrideOriginalValuesRef.current.hasSnapshot &&
        overrideOriginalValuesRef.current.previousOverride
      ) 
      {
        const value = overrideOriginalValuesRef.current.new_fte_annual_salary;

        return hasNoDecimals ? round(Number(value), 0) : Number(value);
      }

      /*
      * ============================================================
      * Change Pay Mix
      *
      * This is completely independent of Override Manager Proposal.
      * ============================================================
      */
      const checkbox = document.querySelector( 'input[name="change_pay_mix"]' );

      const isChangePayMix = checkbox && checkbox.checked;

      /*
      * Change Pay Mix + user entered New ABS
      */
      if ( isChangePayMix && data.new_fte_annual_salary !== undefined ) 
      {
        let v = isNaN(data.new_fte_annual_salary) ? 0 : data.new_fte_annual_salary;

        v = Number(v);

        /* Release 3.2 - 19.1 Starts */
        if (
          data &&
          data.request_type == "internalhire" &&
          selectedItem.incentive_plan_type == "YLIP"
        ) 
        {
          selectedItem.sip_change = true;
        }
        /* Release 3.2 - 19.1 Ends */

        return hasNoDecimals
          ? round(Math.abs(v), 0)
          : Math.abs(v);
      }

      /*
      * Change Pay Mix + request contains New ABS
      */
      if ( isChangePayMix &&  data.request && data.request.new_fte_annual_salary !== undefined ) 
      {
        const v = isNaN( data.request.new_fte_annual_salary )  ? 0  : data.request.new_fte_annual_salary;

        /* Release 3.2 - 19.1 Starts */
        if ( data.request_type &&  data.request_type == "internalhire" && selectedItem.incentive_plan_type == "YLIP" ) 
        {
          selectedItem.sip_change = true;
        }
        /* Release 3.2 - 19.1 Ends */

        return hasNoDecimals ? round(Math.abs(v), 0) : Math.abs(v);
      }

      /*
      * Compensation + Change Pay Mix checked
      *
      * Keep existing New ABS value if available.
      */
      if (
        data.request_type === "compensation" &&
        isChangePayMix
      ) 
      {
        if (
          selectedItem.new_fte_annual_salary !== undefined &&
          selectedItem.new_fte_annual_salary !== null &&
          selectedItem.new_fte_annual_salary !== ""
        ) {
          return Number(
            selectedItem.new_fte_annual_salary
          );
        }
      }

      /*
      * ============================================================
      * Existing SIP logic
      * ============================================================
      */
      if (
        selectedItem.sip_change &&
        !data.request_from
      ) {
        if (
          data.new_fte_annual_salary !== undefined &&
          data.new_fte_annual_salary !== null &&
          data.new_fte_annual_salary !== ""
        ) {
          return Number(data.new_fte_annual_salary);
        }

        if (
          data.request &&
          data.request.new_fte_annual_salary !== undefined &&
          data.request.new_fte_annual_salary !== null &&
          data.request.new_fte_annual_salary !== ""
        ) {
          return Number(data.request.new_fte_annual_salary);
        }

        return selectedItem.new_fte_annual_salary
          ? Number(selectedItem.new_fte_annual_salary)
          : 0;
      }

      /*
      * ============================================================
      * NORMAL New ABS CALCULATION
      *
      * This is the original calculation path.
      *
      * Compensation + TTC Increase Percentage
      * MUST reach this section.
      * ============================================================
      */
      defineFormulaVars();

      if (data.request_type === "compensation") {
        parser.setVariable(
          'totalIncreaseAmount',
          Number(interim_total_increase_amount) || 0
        );
      }

      let formulaToParse =
        getRequiredFormula('New ABS');

      let res = parser.parse(formulaToParse);

      return res.result;
    },
    [selectedItem, config, data]
  );


  const new_fte_incentive_target_amount = useMemo(
    () => {
      if (!selectedItem) return 0;
      console.log("2333");
      /*
      * ============================================================
      * 1. Override Manager Proposal
      * ============================================================
      *
      * When Override Manager Proposal is CHECKED,
      * use the override ITA value directly.
      */
      if (selectedItem.override_manager_proposal) {
      console.log("2343");
        const value =
          selectedItem.override_fte_incentive_target_amount ??
          selectedItem.new_fte_incentive_target_amount ??
          0;

        return hasNoDecimals
          ? round(Number(value), 0)
          : Number(value);
      }


      /*
      * ============================================================
      * 2. Override Manager Proposal UNCHECKED
      * ============================================================
      *
      * If we have a snapshot, restore the original New ITA
      * value that existed before Override Manager Proposal
      * was checked.
      *
      * IMPORTANT:
      * This must be checked before the temporary data value.
      */
      if (
        !selectedItem.override_manager_proposal &&
        overrideOriginalValuesRef.current.hasSnapshot
      ) {
        console.log("2371");
        const value =
          overrideOriginalValuesRef.current
            .new_fte_incentive_target_amount;

        return hasNoDecimals
          ? round(Number(value), 0)
          : Number(value);
      }


      /*
      * ============================================================
      * 3. User entered New ITA
      * ============================================================
      *
      * Keep the existing Our Talent logic.
      */
      /**Release 2 Our Talent some scenarios make Our Talent new intensive target amount dynamic - starts */

      if (data.new_fte_incentive_target_amount !== undefined) {
      console.log("2392");
        const v =
          isNaN(data.new_fte_incentive_target_amount)
            ? 0
            : data.new_fte_incentive_target_amount;

        /* Release 3.2 - 19.1 Starts */
        if (
          data &&
          data.request_type == "internalhire" &&
          selectedItem.incentive_plan_type == "YLIP"
        ) {console.log("2403");
          selectedItem.sip_change = true;
        }
        /* Release 3.2 - 19.1 Ends */

        return hasNoDecimals
          ? round(Math.abs(v), 0)
          : Math.abs(v);
      }


      /*
      * If the value is available inside data.request,
      * use that value.
      */
      if (
        data.request &&
        data.request.new_fte_incentive_target_amount !== undefined
      ) {
      console.log("2422");
        const v =
          isNaN(
            data.request.new_fte_incentive_target_amount
          )
            ? 0
            : data.request.new_fte_incentive_target_amount;

        /* Release 3.2 - 19.1 Starts */
        if (
          data.request_type &&
          data.request_type == "internalhire" &&
          selectedItem.incentive_plan_type == "YLIP"
        ) {console.log("2435");
          selectedItem.sip_change = true;
        }
        /* Release 3.2 - 19.1 Ends */

        return hasNoDecimals
          ? round(Math.abs(v), 0)
          : Math.abs(v);
      }


      /*
      * ============================================================
      * 4. Change Pay Mix
      * ============================================================
      *
      * New ITA remains an independent value.
      *
      * Do NOT calculate New ITA from TTC here.
      */
      if (
        data.request_type === "compensation"
      ) {
      console.log("2458");
        const checkbox = document.querySelector(
          'input[name="change_pay_mix"]'
        );

        if (checkbox && checkbox.checked) {console.log("2463");

          /*
          * If New ITA is entered by the user,
          * use the entered value.
          */
          if (
            data.new_fte_incentive_target_amount !== undefined &&
            data.new_fte_incentive_target_amount !== null &&
            data.new_fte_incentive_target_amount !== ""
          ) {
        console.log("2474");
            const value =
              Number(
                data.new_fte_incentive_target_amount
              ) || 0;

            return hasNoDecimals
              ? round(Math.abs(value), 0)
              : Math.abs(value);
          }


          /*
          * If New ITA is available in request,
          * use that value.
          */
          if (
            data.request &&
            data.request.new_fte_incentive_target_amount !== undefined &&
            data.request.new_fte_incentive_target_amount !== null &&
            data.request.new_fte_incentive_target_amount !== ""
          ) {
        console.log("2496");
            const value =
              Number(
                data.request.new_fte_incentive_target_amount
              ) || 0;

            return hasNoDecimals
              ? round(Math.abs(value), 0)
              : Math.abs(value);
          }


          /*
          * If New ITA already exists on selectedItem,
          * keep that value.
          */
          if (
            selectedItem.new_fte_incentive_target_amount !== undefined &&
            selectedItem.new_fte_incentive_target_amount !== null &&
            selectedItem.new_fte_incentive_target_amount !== ""
          ) {
        console.log("2517");
            return Number(
              selectedItem.new_fte_incentive_target_amount
            );
          }
        }
      }


      /*
      * ============================================================
      * 5. No snapshot + no new user-entered ITA
      * ============================================================
      *
      * Keep the existing New ITA value.
      *
      * This prevents the formula from changing the existing
      * New ITA unexpectedly.
      */
      /*if (
        !selectedItem.override_manager_proposal &&
        !overrideOriginalValuesRef.current.hasSnapshot &&
        selectedItem.new_fte_incentive_target_amount !== undefined &&
        selectedItem.new_fte_incentive_target_amount !== null &&
        selectedItem.new_fte_incentive_target_amount !== ""
      ) {
        console.log("2543");
        return hasNoDecimals
          ? round(
              Number(
                selectedItem.new_fte_incentive_target_amount
              ),
              0
            )
          : Number(
              selectedItem.new_fte_incentive_target_amount
            );
      }*/


      /*
      * ============================================================
      * 6. SIP Change
      * ============================================================
      */
      if (
        selectedItem.sip_change &&
        !data.request_from
      ) {
      console.log("2566");
        return selectedItem.new_fte_incentive_target_amount
          ? selectedItem.new_fte_incentive_target_amount
          : 0;
      }


      /**Release 2 Our Talent some scenarios make Our Talent new intensive target amount dynamic - Ends */


      let value = 0;

      /*
      * Old Override Manager Proposal logic
      * intentionally kept commented.
      */

      /*if (selectedItem.override_manager_proposal) {
        value =
          selectedItem.override_fte_incentive_target_amount ||
          selectedItem.new_fte_incentive_target_amount;

        return hasNoDecimals
          ? round(value, 0)
          : value;
      }*/


      /*
      * ============================================================
      * 7. New ITA Formula
      * ============================================================
      */
      defineFormulaVars();
      console.log("2600");
      console.log("selectedItem====>", selectedItem)
      let formulaToParse =
        getRequiredFormula('New ITA');

      let res =
        parser.parse(formulaToParse);

      return res.result;
    },
    [selectedItem, config, ttc_increase_amount, data]
  );

  const new_incentive_target_percentage = useMemo(
    () =>{
        if(selectedItem){
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('New ITP');
            let res = parser.parse(formulaToParse);
            return res.result;
        }else{
            return 0;
        }
    },
    [selectedItem]
  );

  const new_fte_ttc_annual_salary = useMemo(
    () => {
      if (!selectedItem) {
        return 0;
      }

      defineFormulaVars();

      /*
      * IMPORTANT:
      * New TTC must use the CURRENT calculated
      * New ABS and New ITA values.
      *
      * Do not rely only on selectedItem here because
      * updateEmployeeData() runs in useEffect after
      * the current calculation/render.
      */
      parser.setVariable(
        'newAbs',
        Number(new_fte_annual_salary) || 0
      );

      parser.setVariable(
        'newIta',
        Number(new_fte_incentive_target_amount) || 0
      );

      console.log("===== NEW TTC TRACE =====");
      console.log("data.ttc_increase_percentage =", data.ttc_increase_percentage);
      console.log("ttc_increase_amount =", ttc_increase_amount);
      console.log("interim_total_increase_amount =", interim_total_increase_amount);
      console.log("new_fte_annual_salary =", new_fte_annual_salary);
      console.log("new_fte_incentive_target_amount =", new_fte_incentive_target_amount);
      console.log("selectedItem.new_fte_annual_salary =", selectedItem.new_fte_annual_salary);
      console.log("selectedItem.new_fte_incentive_target_amount =", selectedItem.new_fte_incentive_target_amount);
      console.log("=========================");

      let formulaToParse = getRequiredFormula('New TTC');

      let res = parser.parse(formulaToParse);

      return res.result;
    },
    [
      selectedItem,
      config,
      new_fte_annual_salary,
      new_fte_incentive_target_amount
    ]
  );

  const new_itp_situation = useMemo(
    () =>{
      if(selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('New ITP Situation');
        //console.log('newItp',parser.getVariable('newItp'))
        //console.log('interimTheoItp',parser.getVariable('interimTheoItp'))
        //IF(newItp=interimTheoItp,"Norm",IF(newItp>interimTheoItp,"High","Low"))
        let res = parser.parse(formulaToParse);
        return res.result;
      }else{
          return 'Norm';
      }
    },
    [selectedItem]
  );

  const new_ttc_check = useMemo(
    () => {
      if (selectedItem && selectedItem.new_fte_ttc_annual_salary) {
        //IF(ROUND((newTtc*100)/100,0)=ROUND(((curSalary+mandatoryTtcIncreaseDueToPromotion+totalIncreaseAmount)*100)/100,0),true,false)
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('TTC Check');
        //console.log('totalIncreaseAmount', parser.getVariable('totalIncreaseAmount'));
        let res = parser.parse(formulaToParse);
        //console.log('parsed TTC Check', res)
        return res.result;
      }
      return false;
    },
    [selectedItem]
  );

  const new_ttc_compa_ratio = useMemo(
    () => {
      if (selectedItem) {
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('New TTC Compa-Ratio');
        //IF(AND(newTtc>0,newSrMid>0)=true,newTtc/newSrMid,currentCR)
        //console.log('newTtc',parser.getVariable('newTtc'))
        //console.log('newSrMid',parser.getVariable('newSrMid'))
        //console.log('currentCR',parser.getVariable('currentCR'))
        //console.log('AND(newTtc>0,newSrMid>0)',parser.parse('AND(newTtc>0,newSrMid>0)'))
        let res = parser.parse(formulaToParse);
        //console.log('new compa is ',res)
        return res.error=="#DIV/0!"?Infinity:res.result;
      }
      return 0.00;
    },
    [selectedItem]
  );

  const new_quartile = useMemo(
    () => {

      if(selectedItem && selectedItem.new_ttc_compa_ratio)
      {
        if(Number.isFinite(selectedItem.new_ttc_compa_ratio) == false)
        {
          return 'NA';
        }
        else
        {
          if (selectedItem && selectedItem.new_ttc_compa_ratio > 0) 
          {
            defineFormulaVars(); //refresh the values of formula variables
            let formulaToParse = getRequiredFormula('New Quartile');
            let res = parser.parse(formulaToParse);
            //console.log('parsed new quartile', res)
            return res.result;
          }
        }
      }

      /*if (selectedItem && selectedItem.new_ttc_compa_ratio > 0) {
        //console.log('new compa ratio', selectedItem.new_ttc_compa_ratio)
       // console.log('new compa ratio parsed', parser.getVariable('newCR'))
        //console.log('interim_salary_range_spread',  selectedItem.interim_salary_range_spread)
        //console.log('Parsing new quartile', parser.parse('IFERROR((newSrRangeSpread/2),0)'))
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('New Quartile');
        let res = parser.parse(formulaToParse);
        //console.log('parsed new quartile', res)
        return res.result;
      }   
      return 'NA';*/
    },
    [selectedItem]
  );

  /*const new_incentive_plan_type = useMemo(
    () =>{
        if(selectedItem){
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('New Incentive Plan Type');
          //IF(AND(incentivePlan="YPDI",currentJobGrade=12,interimJobGrade="13"),"YMDI",incentivePlan)
          console.log('incentivePlan',parser.getVariable('incentivePlan'))
          console.log('currentJobGrade',parser.getVariable('currentJobGrade'))
          console.log('interimJobGrade',parser.getVariable('interimJobGrade'))
          let res = parser.parse(formulaToParse);
          console.log('parsed new_incentive_plan_type',res)
          return res.result;
        }else{
          return '';
        }
    },
    [selectedItem]
  );*/

  /* DMND0003988_NBS:Point1: Allow movements in and out of Pre Sales/ Sales Job family Starts */
  /*const new_incentive_plan_type = useMemo(
    () =>
    {
      if(selectedItem)
      {
        //console.log("IN_PLAN_TYPE 1");
        if(data.request_type == "internalhire")
        {
          //console.log("IN_PLAN_TYPE 2");
          if ((selectedItem.promotion_job_family_name == "Sales" || selectedItem.promotion_job_family_name == "Pre-Sales"))
          {
            //console.log("IN_PLAN_TYPE 3");
            return 'YSIP';
          }
          else
          {
            //console.log("IN_PLAN_TYPE 4");
            if ((selectedItem.promotion_job_family_name != "Sales" || selectedItem.promotion_job_family_name != "Pre-Sales"))
            {
              if(selectedItem.job_grade >= 12 && selectedItem.interim_job_grade >= 13)
                return 'YMDI';
              else 
                return 'YPDI';
            }
            else
            {
              if(selectedItem.incentive_plan_type === 'YPDI' && selectedItem.job_grade == 12 && selectedItem.interim_job_grade == 13)
                return 'YMDI';
              else
                return selectedItem.incentive_plan_type;
            }
          }
        }
        else
        {
          //console.log("IN_PLAN_TYPE 5");
          if(selectedItem.incentive_plan_type === 'YPDI' && selectedItem.job_grade == 12 && selectedItem.interim_job_grade == 13)
            return 'YMDI';
          else
            return selectedItem.incentive_plan_type;
        }
      }
    },
    [selectedItem, data]
  );*/

  const new_incentive_plan_type = useMemo(
    () =>
    {
      if(selectedItem)
      {
          //console.log("IN_PLAN_TYPE 2");
          if(selectedItem.incentive_plan_type === 'License Incentive Plan')
          {
            return 'TLIP';
          }
          else
          {
            if ((selectedItem.promotion_job_family_name == "Sales" || selectedItem.promotion_job_family_name == "Pre-Sales"))
            {
              //console.log("IN_PLAN_TYPE 3");
              return 'YSIP';
            }
            else
            {
              //console.log("IN_PLAN_TYPE 4");
              if ((selectedItem.promotion_job_family_name != "Sales" || selectedItem.promotion_job_family_name != "Pre-Sales"))
              {
                if(selectedItem.job_grade >= 12 && selectedItem.interim_job_grade >= 13)
                  return 'YMDI';
                else 
                  return 'YPDI';
              }
              else
              {
                if(selectedItem.incentive_plan_type === 'YPDI' && selectedItem.job_grade == 12 && selectedItem.interim_job_grade == 13)
                  return 'YMDI';
                else
                  return selectedItem.incentive_plan_type;
              }
            }
          }
          
      }
    },
    [selectedItem, data]
  );
  /* DMND0003988_NBS:Point1: Allow movements in and out of Pre Sales/ Sales Job family Ends */
  
  const individual_budget_amount = useMemo(
    () =>{
      if(!selectedItem) return 0;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Individual Budget');
      let res = parser.parse(formulaToParse);
      return res.result;
    },
    [selectedItem]
  );

  const individual_spending_amount = useMemo(
    //merit+IF(AND(currentJobGrade=6,newJobGrade=7,tenure>=1.5,tenure<=4),0,mandatoryTtcIncreaseDueToPromotion)
    () =>{
    if (selectedItem){
      //merit + (isGppEligible ? 0 : mandatoryTtcIncreaseDueToPromotion)
      let formulaToParse = getRequiredFormula('Individual Spending');
      defineFormulaVars(); //refresh the values of formula variables
      //console.log('merit',parser.getVariable('merit'))
      //console.log('currentJobGrade',parser.getVariable('currentJobGrade'))
      //console.log('newJobGrade',parser.getVariable('newJobGrade'))
      //console.log('tenure',parser.getVariable('tenure'))
      //console.log('isGppEligible',parser.getVariable('isGppEligible'))
      //console.log('mandatoryTtcIncreaseDueToPromotion',parser.getVariable('mandatoryTtcIncreaseDueToPromotion'))
      //console.log('tenure check',parser.parse('merit + (isGppEligible ? 0 : mandatoryTtcIncreaseDueToPromotion)'))
      let res = parser.parse(formulaToParse);
      //console.log('parsed Individual Spending',res)
      return res.result;
  }else{
      return 0;
  }
},
    [selectedItem]
  );

  const individual_balance_amount = useMemo(
    //individualBudgetAmount-individualSpendingAmount
    () =>{
      if (selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Individual Balance');
        let res = parser.parse(formulaToParse);
        return res.result;
    }else{
        return 0;
    }
  },
    [selectedItem]
  );

  const gpp_budget = useMemo(
    //IF(AND(promoted=true,currentJobGrade=06,newJobGrade=07,tenure>=1.5,tenure<=4),curSalary *( gppGuidelineMax / 100) + mandatoryTtcIncreaseDueToPromotion,0)
    () =>{
      if (selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('GPP Budget');
        // console.log('promoted',parser.getVariable('promoted'))
        // console.log('currentJobGrade',parser.getVariable('currentJobGrade'))
        // console.log('newJobGrade',parser.getVariable('newJobGrade'))
        // console.log('tenure',parser.getVariable('tenure'))
        // console.log('curSalary',parser.getVariable('curSalary'))
        // console.log('gppGuidelineMax',parser.getVariable('gppGuidelineMax'))
        // console.log('mandatoryTtcIncreaseDueToPromotion',parser.getVariable('mandatoryTtcIncreaseDueToPromotion'))
        let res = parser.parse(formulaToParse);
        //console.log('parsed GPP budget',res)
        return res.result;
    }else{
        return 0;
    }
  },
    [selectedItem]
  );

  const gpp_spending = useMemo(
    //IF(AND(promoted="YES",currentJobGrade = 6,newJobGrade = 7,tenure >= 1.5,tenure <= 4), lumpSum2+mandatoryTtcIncreaseDueToPromotion,0)
    () =>{
      if (selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('GPP Spending');
        let res = parser.parse(formulaToParse);
        //console.log('parsed GPP Spending',res)
        return res.result;
    }else{
        return 0;
    }
  },
    [selectedItem]
  );

  const gpp_balance = useMemo(
    //gppBudget - gppSpending
    () =>{
      if (selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('GPP Balance');
        let res = parser.parse(formulaToParse);
        return res.result;
    }else{
        return 0;
    }
  },
    [selectedItem]
  );

  const total_spending = useMemo(
    //merit+IF(AND(currentJobGrade=6,newJobGrade=7,tenure>=1.5,tenure<=4),gppSpending,0)
    () =>{
      if (selectedItem){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Overall Total Spending');
        // console.log('merit',parser.getVariable('merit'))
        // console.log('currentJobGrade',parser.getVariable('currentJobGrade'))
        // console.log('newJobGrade',parser.getVariable('newJobGrade'))
        // console.log('tenure',parser.getVariable('tenure'))
        // console.log('gppSpending',parser.getVariable('gppSpending'))
        let res = parser.parse(formulaToParse);
        //console.log('parsed Overall Total Spending total_spending',res)
        return res.result;
    }else{
        return 0;
    }
  },
    [selectedItem]
  );

  const offcycle_budget_update = useMemo(
    () =>{
      if (selectedItem && selectedItem.new_fte_ttc_annual_salary){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Off Cycle Budget Update');
        //(newTtc-curSalary)
        //console.log('newTtc new_fte_ttc_annual_salary',parser.getVariable('newTtc'))
        //console.log('curSalary fte_ttc_annual_salary',parser.getVariable('curSalary'))
        let res = parser.parse(formulaToParse);
        //console.log('parsed Off Cycle Budget Update', res)
        return res.result;
      }else{
          return 0;
      }
    },
    [selectedItem]
  );

  const payment_type = useMemo(
    () => {
      const activeData = data.request ? data.request : data;
      if (activeData.payment_type) return activeData.payment_type;
      let paymentType = filterPaymentTypes()[0];
      if (selectedItem && selectedItem.payment_type) {
        paymentType = selectedItem.payment_type
      }
      return paymentType;
    },
    [selectedItem, data]
  );

  const payment_reason = useMemo(
    () => {
      return selectedItem && selectedItem.payment_reason ? selectedItem.payment_reason : "Merit lump-sum";
    },
    [selectedItem]
  );

  const target_budget_org = useMemo(
    () => {
      const column = columns.find(c => c.name === "target_budget_org");
      const isAllowed = (column, account) => {
        if (column.allow) {
          return column.allow.find(role => account.roles.find(arole => arole === role));
        }
        return true;
      };
      // Not Allowed for role
      if (!column || !isAllowed(column, account)) return undefined;
      // Manual change
      const activeData = data.request ? data.request : data;
      if (activeData.target_budget_org) return activeData.target_budget_org;
      //IF(targetBudgetOrg,targetBudgetOrg,IF(orgUnit4,orgUnit4,IF(orgUnit3,orgUnit3,IF(orgUnit2,orgUnit2,IF(orgUnit1,orgUnit1,"undefined")))))
      if (selectedItem){
        if(selectedItem.target_budget_org){
         return selectedItem.target_budget_org;
        }else{
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Target Budget Org');
          //IF(targetBudgetOrg,targetBudgetOrg,IF(orgUnit4,orgUnit4,IF(orgUnit3,orgUnit3,IF(orgUnit2,orgUnit2,IF(orgUnit1,orgUnit1,"undefined")))))
          //console.log('unit 4',parser.parse('IF(orgUnitFour<>"",orgUnitFour,"wow")'))
          let res = parser.parse(formulaToParse);
          //console.log('parsed Target Budget Org', res)
          return (res.result=="undefined" || res.result=="null")?undefined:res.result;
        }
        
      }else{
          return undefined;
      }
    },
    [selectedItem, data, columns, account]
  );
  /**Release 2 Our Talent - starts*/
  const sip_change = useMemo(
    () => {
      if (selectedItem) {
        if (data && data.request_type == "internalhire" && data.promotion_job_family_name) {
          if(selectedItem.job_family_name === data.promotion_job_family_name  ){
            return false;
          }
          else if ((selectedItem.job_family_name == "Sales" || selectedItem.job_family_name == "Pre-Sales") || (data.promotion_job_family_name == "Pre-Sales" || data.promotion_job_family_name == "Sales" )) {
            return true;
          }

          else {
            return false;
          }
        }
        else  if (data.request && data.request_type == "internalhire" && data.request.promotion_job_family_name) {
          if(selectedItem.job_family_name === data.request.promotion_job_family_name  ){
            return false;
          }
          else if ((selectedItem.job_family_name == "Sales" || selectedItem.job_family_name == "Pre-Sales") || (data.request.promotion_job_family_name == "Pre-Sales" || data.request.promotion_job_family_name == "Sales" )) {
            return true;
          }

          else {
            return false;
          }
        }
        else if (selectedItem.sip_change) {
          return selectedItem.sip_change;
        }
      }
    },
    [selectedItem, data]
  )
  const current_combo_situation = useMemo(
    () => {
      if (selectedItem) {
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Current Combo Situation');
        //getCountriesGradeProgressions(country)&" and "&currentQuartile
        let res = parser.parse(formulaToParse);
        //console.log('parsed current_combo_situation', res)
        return res.result;
      }
      else {
        return "";
      }
    },
    [selectedItem, config]
  );
  const promo_increase_pct_guideline_min = useMemo(
    () => {
      if (!selectedItem || !selectedItem.current_combo_situation) return 0.00;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Promotional increase % Guideline MIN');
      //getIncreaseGuidelines('min',currentComboSituation)
      let res = parser.parse(formulaToParse);
      //console.log('parsed promo_increase_pct_guideline_min', res)
      return res.result;
    },
    [selectedItem, config]
  );
  const promo_increase_pct_guideline_max = useMemo(
    () => {
      if (!selectedItem || !selectedItem.current_combo_situation) return 0.00;
      defineFormulaVars(); //refresh the values of formula variables
      let formulaToParse = getRequiredFormula('Promotional increase % Guideline MAX');
      //getIncreaseGuidelines('max',currentComboSituation)
      let res = parser.parse(formulaToParse);
      //console.log('parsed promo_increase_pct_guideline_max', res)
      return res.result;
    },
    [selectedItem, config]
  );

  const promotional_increase_percentage_guideline = useMemo(
    () => {
      if (selectedItem) {
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Promotional increase % Guideline');
        //(promoIncreasePctGuidelineMin*100)&"% to "&(promoIncreasePctGuidelineMax*100)&"%"
        let res = parser.parse(formulaToParse);
        //console.log('parsed promotional_increase_percentage_guideline', res)
        return res.result;
      }
      else {
        return "";
      }
    },
    [selectedItem]
  );
  const rr_number = useMemo(
    () => {
      if (selectedItem) {
        if (data.rr_number !== undefined) {
          return data.rr_number;
        }
        else if (data.request && data.request.rr_number !== undefined) {
          return data.request.rr_number;
        }
        else {
          return selectedItem.rr_number;
        }
      }
    },
    [selectedItem, data]
  );
  const case_3_12_month_actual_incentive_amount_fte = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.sip_change) {

          if (data.case_3_12_month_actual_incentive_amount_fte !== undefined) {
            const v = isNaN(data.case_3_12_month_actual_incentive_amount_fte) ? 0 : data.case_3_12_month_actual_incentive_amount_fte;
            return Math.abs(v);
          }
          /* Release 3.2 - 13.1 - Starts */
          else if (data.request !== undefined && data.request.case_3_12_month_actual_incentive_amount_fte !== undefined) {
            const v = isNaN(data.request.case_3_12_month_actual_incentive_amount_fte) 
            ?  0 : 
            data.request.case_3_12_month_actual_incentive_amount_fte;
            return Math.abs(v);
          }
          /* Release 3.2 - 13.1 - Ends */
          else if (selectedItem.case_3_12_month_actual_incentive_amount_fte) { return selectedItem.case_3_12_month_actual_incentive_amount_fte; }
          else {
            return 0;
          }
        }
        else {
          // return 0;
          /* Release 3.2 - 13.1 - Starts */
          let case_3_12_month_actual_incentive_amount_fte = 0;

          if (data.case_3_12_month_actual_incentive_amount_fte !== undefined) {
            case_3_12_month_actual_incentive_amount_fte = isNaN(
              data.case_3_12_month_actual_incentive_amount_fte
            )
              ? 0
              : data.case_3_12_month_actual_incentive_amount_fte;
          }
          else if (data.request !== undefined && data.request.case_3_12_month_actual_incentive_amount_fte !== undefined) {
            case_3_12_month_actual_incentive_amount_fte = isNaN(data.request.case_3_12_month_actual_incentive_amount_fte) 
            ? 0 
            : data.request.case_3_12_month_actual_incentive_amount_fte;
          }
          else if (selectedItem.case_3_12_month_actual_incentive_amount_fte) { 
            case_3_12_month_actual_incentive_amount_fte = selectedItem.case_3_12_month_actual_incentive_amount_fte; 
          }

          return Math.abs(case_3_12_month_actual_incentive_amount_fte);
          /* Release 3.2 - 13.1 - Ends */
        }
      }
    },
    [selectedItem, data]
  );
  const override_transition_allowance_local_currency = useMemo(
    () => {
      if (selectedItem) {
        if (selectedItem.sip_change) {
          if (data.override_transition_allowance_local_currency !== undefined) {
            const v = isNaN(data.override_transition_allowance_local_currency) ? 0 : data.override_transition_allowance_local_currency;
            return Math.abs(v);
          }
          else if (selectedItem.override_transition_allowance_local_currency) {
            return selectedItem.override_transition_allowance_local_currency;
          }
          else {
            return 0;
          }
        }
        else {
          return 0;
        }
      }
    },
    [selectedItem, data]
  );

  const internalhire_off_cycle_spending = useMemo(
    () => {
      if (selectedItem) {
      if(data.request_type == "internalhire"){
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Amount tracked against off cycle budget (Local currency)');
        //IF(promoted=true,IF(ttc_increase_pct<=(promoIncreasePctGuidelineMax*100),0,IF(ttc_increase_pct>(promoIncreasePctGuidelineMax*100),((ttc_increase_pct-(promoIncreasePctGuidelineMax*100))/100)*curSalary,0)),IF(newTtc>0,newTtc-curSalary,0))
        // console.log('promoted',parser.getVariable('promoted'))
        // console.log('ttc_increase_pct',parser.getVariable('ttc_increase_pct'))
        // console.log('promoIncreasePctGuidelineMax',parser.getVariable('promoIncreasePctGuidelineMax'))
        // console.log('curSalary',parser.getVariable('curSalary'))
        let res = parser.parse(formulaToParse);
        //console.log('parsed internalhire_off_cycle_spending', res)
        return res.result;
      } 
    }
    },
    [selectedItem, data]
  )
  const internal_hire_off_cycle_spending_euro = useMemo(
    () => {
      if (selectedItem) {
        if (!selectedItem.offcycle_budget_update) { return 0; }
        defineFormulaVars(); //refresh the values of formula variables
        //console.log('offCycleSpending',parser.getVariable('offCycleSpending'))
        //console.log('exchangeRate',parser.getVariable('exchangeRate'))
        let formulaToParse = getRequiredFormula('Amount tracked against off cycle budget EURO');
        //IF(exchangeRate<>null,offCycleSpending*exchangeRate,0)
        let res = parser.parse(formulaToParse);
        //console.log('parsed internal_hire_off_cycle_spending_euro', res)
        return res.result;
      }
    },
    [selectedItem]
  );

  const is_sip = useMemo(
    () => {
      if (selectedItem) {
        if (selectedItem.promotion_job_family_name) {
          if ((selectedItem.promotion_job_family_name !== 'Sales' && selectedItem.promotion_job_family_name !== 'Pre-Sales') && (selectedItem.job_family_name !== 'Sales' && selectedItem.job_family_name !== "Pre-Sales")) {
            return false;
          }
          else if(selectedItem.promotion_job_family_name == selectedItem.job_family_name) {
            return false;
          }
          else{
            return true;
          }
        }
        else {
          return false;
        }
      }
    },
    [selectedItem]
  );

  const Max_Promotional_Increase = useMemo(
    () => {
      if(selectedItem){
        //return selectedItem.promoted ? selectedItem.promo_increase_pct_guideline_max:0;
        //IF(promoted=true,promoIncreasePctGuidelineMax,0)
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Max Promotional Increase');
        let res = parser.parse(formulaToParse);
        //console.log('parsed Max_Promotional_Increase', res)
        return res.result;
      }

    },
    [selectedItem]
  )

  const Case_One_Max_Budget_calc = useMemo(
    () => {
      
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 1 Max Budget calc');
          //IF(IF(newTheoItp=100,currentFteAbs*0.8+(currentFteAbs*0.8*(newTheoItp/100))-curSalary,(currentFteAbs*0.9)+(currentFteAbs*0.9*(newTheoItp/100))-curSalary)<=0,0,IF(newTheoItp=100,currentFteAbs*0.8+(currentFteAbs*0.8*(newTheoItp/100))-curSalary,(currentFteAbs*0.9)+(currentFteAbs*0.9*(newTheoItp/100))-curSalary))
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_One_Max_Budget_calc', res)
          return res.result;
        }else{
          return 0;
        }
      }
      
        //IF(IF(newTheoItp=100,currentFteAbs*0.8+(currentFteAbs*0.8*(newTheoItp/100))-curSalary,(currentFteAbs*0.9)+(currentFteAbs*0.9*(newTheoItp/100))-curSalary)<=0,0,IF(newTheoItp=100,currentFteAbs*0.8+(currentFteAbs*0.8*(newTheoItp/100))-curSalary,(currentFteAbs*0.9)+(currentFteAbs*0.9*(newTheoItp/100))-curSalary))
        

    },
    [selectedItem]
  );
  const Case_one_TTC_increase_minus_Max_budget = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 1 TTC increase minus Max budget');
          //merit-CaseOneMaxBudgetcalc
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_one_TTC_increase_minus_Max_budget', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );
  const Case_one_Budget_charge = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 1 Budget charge');
          //IF(CaseOneTTCIncreaseMinusMaxBudget<=0,0,CaseOneTTCIncreaseMinusMaxBudget)
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_one_Budget_charge', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );
  const Case_two_TI_Increase = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 2 TI Increase');
          //IF(CaseOneMaxBudgetcalc<>null,CaseOneMaxBudgetcalc,0)
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_two_TI_Increase', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );

  const Case_two_Promotion_Budget = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
        defineFormulaVars(); //refresh the values of formula variables
        let formulaToParse = getRequiredFormula('Case 2 Promotion Budget');
        //IF(promoted=true,curSalary*promoIncreasePctGuidelineMax,0)
        let res = parser.parse(formulaToParse);
        //console.log('parsed Case_two_Promotion_Budget', res)
        return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );

  const Case_two_Total_budget = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 2 Total budget');
          //caseTwoTIIncrease+caseTwoPromotionBudget
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_two_Total_budget', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );

  const Case_two_Budget_charge = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 2 Budget charge');
          //IF(merit-caseTwoTotalBudget<=0,0,merit-caseTwoTotalBudget)
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_two_Budget_charge', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );

  const Case_three_twelve_month_Total_Target_Cash = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 3 -12 month Total Target Cash');
          //currentFteAbs+caseThreeTwelveMonthActualIncentiveAmountPaid
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_three_twelve_month_Total_Target_Cash', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );

  const Case_three_new_TTC_Gap_to_twelve_month_TTC = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 3 new TTC Gap to -12month TTC');
          //caseThreeTwelveMonthTotalTargetCash-newTtc
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_three_new_TTC_Gap_to_twelve_month_TTC', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );

  const Case_three_Max_capped_transit_allowance = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 3 Max capped transit allowance');
          //caseThreeTwelveMonthActualIncentiveAmountPaid*0.5
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_three_Max_capped_transit_allowance', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );
  const Case_three_Transition_allowance_total = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 3 Transition allowance total');
          //IF(caseThreeNewTTCGapToTwelveMonthTTC>0,MIN(caseThreeMaxCappedTransitAllowance,caseThreeNewTTCGapToTwelveMonthTTC),0)
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_three_Transition_allowance_total', res)
          return res.result;
        }else{
          return 0;
        }
      }

    },
    [selectedItem]
  );


  const Case_three_Budget_charge = useMemo(
    () => {
      if (selectedItem) {

        if (selectedItem.is_sip) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Case 3 Budget charge');
          //IF(IF(OverrideTransitionAllowanceLocalCurrency<>null,OverrideTransitionAllowanceLocalCurrency+(newTtc-curSalary-(currentFteAbs*maxPromoIncrease)), caseThreeTransitionAllowanceTotal+( newTtc-curSalary - (currentFteAbs*maxPromoIncrease)))<=0,0,IF(OverrideTransitionAllowanceLocalCurrency<>null,OverrideTransitionAllowanceLocalCurrency+(newTtc-curSalary-(currentFteAbs*maxPromoIncrease)), caseThreeTransitionAllowanceTotal+( newTtc-curSalary - (currentFteAbs*maxPromoIncrease))))
          let res = parser.parse(formulaToParse);
          //console.log('parsed Case_three_Budget_charge', res)
          return res.result;
        }else{
          return 0;
        }

      }

    },
    [selectedItem]
  );
  const sip_case = useMemo(() => {
    if (selectedItem) {
      const currentJobFamily = selectedItem.job_family_name != "Pre-Sales" && selectedItem.job_family_name != "Sales" ? "Non-Sales" : selectedItem.job_family_name;
      const promo_status = selectedItem.promoted ? "YES" : "NO";
      const targetjobfamily = selectedItem.promotion_job_family_name != "Pre-Sales" && selectedItem.promotion_job_family_name != "Sales" ? "Non-Sales" : selectedItem.promotion_job_family_name;
      if (selectedItem.promotion_job_family_name) {
        return currentJobFamily + " to " + targetjobfamily + " Promo " + promo_status;
      }
      else {
        return currentJobFamily + " to " + currentJobFamily + " Promo " + promo_status;
      }
    }
  },
    [selectedItem])
  const Final_Off_Cycle_Budget = useMemo(
    () => {
      if (selectedItem) {
        if (selectedItem.sip_case) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Final Off-Cycle Budget');
          //IF(sipCase="Non-Sales to Sales Promo NO",IF(caseOneBudgetCharge<=0,0,caseOneBudgetCharge), IF(sipCase="Non-Sales to Pre-Sales Promo NO",IF(caseOneBudgetCharge<=0,0,caseOneBudgetCharge), IF(sipCase="Non-Sales to Sales Promo YES",IF(caseTwoBudgetCharge<=0,0,caseTwoBudgetCharge), IF(sipCase="Non-Sales to Pre-Sales Promo YES",IF(caseTwoBudgetCharge<=0,0,caseTwoBudgetCharge), IF(sipCase="Sales to Non-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge), IF(sipCase="Sales to Non-Sales Promo YES",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge), IF(sipCase="Pre-Sales to Non-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge), IF(sipCase="Pre-Sales to Non-Sales Promo YES",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge), IF(sipCase="Pre-Sales to Sales Promo YES",IF(caseTwoBudgetCharge<=0,0,caseTwoBudgetCharge), IF(sipCase="Pre-Sales to Sales Promo NO",IF(caseOneBudgetCharge<=0,0,caseOneBudgetCharge), IF(sipCase="Sales to Pre-Sales Promo YES",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge), IF(sipCase="Sales to Pre-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge), IF(sipCase="Sales to Pre-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge), offCycleSpending)))))))))))))
          let res = parser.parse(formulaToParse);
          //console.log('parsed Final_Off_Cycle_Budget', res)
          return res.result;          
        }
        else { return ""; }
      }
    },
    [selectedItem]
  );
  const Final_Off_Cycle_Budget_euro = useMemo(
    () => {
      if (selectedItem) {
        if (selectedItem.sip_case) {
          defineFormulaVars(); //refresh the values of formula variables
          let formulaToParse = getRequiredFormula('Final Off-Cycle Budget € (Depending on the case)');

          //IF(sipCase="Non-Sales to Sales Promo NO",IF(caseOneBudgetCharge<=0,0,caseOneBudgetCharge*exchangeRate), IF(sipCase="Non-Sales to Pre-Sales Promo NO",IF(caseOneBudgetCharge<=0,0,caseOneBudgetCharge*exchangeRate), IF(sipCase="Non-Sales to Sales Promo YES",IF(caseTwoBudgetCharge<=0,0,caseTwoBudgetCharge*exchangeRate), IF(sipCase="Non-Sales to Pre-Sales Promo YES",IF(caseTwoBudgetCharge<=0,0,caseTwoBudgetCharge*exchangeRate), IF(sipCase="Sales to Non-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge*exchangeRate), IF(sipCase="Sales to Non-Sales Promo YES",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge*exchangeRate), IF(sipCase="Pre-Sales to Non-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge*exchangeRate), IF(sipCase="Pre-Sales to Non-Sales Promo YES",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge*exchangeRate), IF(sipCase="Pre-Sales to Sales Promo YES",IF(caseTwoBudgetCharge<=0,0,caseTwoBudgetCharge*exchangeRate), IF(sipCase="Pre-Sales to Sales Promo NO",IF(caseOneBudgetCharge<=0,0,caseOneBudgetCharge*exchangeRate), IF(sipCase="Sales to Pre-Sales Promo YES",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge*exchangeRate), IF(sipCase="Sales to Pre-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge*exchangeRate), IF(sipCase="Sales to Pre-Sales Promo NO",IF(caseThreeBudgetCharge<=0,0,caseThreeBudgetCharge*exchangeRate), offCycleSpendingInEUR)))))))))))))
          //console.log('offCycleSpendingInEUR', parser.getVariable('offCycleSpendingInEUR'))
          let res = parser.parse(formulaToParse);
          //console.log('parsed Final_Off_Cycle_Budget EUR', res)
          return res.result; 
        }
        else { return ""; }
      }
    },
    [selectedItem]
  );
  const internalhire_increase_amount   = useMemo(
    () => {
      return selectedItem ? selectedItem.ttc_increase_amount : 0;
     },
     [selectedItem]
  )
  const internalhire_increase_percentage   = useMemo(
    () => {
      return selectedItem ? selectedItem.ttc_increase_percentage : 0;
     },
     [selectedItem]
  )
  const hiring_manager = useMemo(
    () => {
      if(selectedItem){
        const ActiveData= data.request ? data.request : data;
        return ActiveData.hiringmanager ? ActiveData.hiringmanager : ( selectedItem.hiring_manager ? selectedItem.hiring_manager : ""); 

      }
    },
    [selectedItem, data]
  )
  /* Release 3.2 - 13.1 - Starts */
  const sum_of_pay_amount = useMemo(() => {
    if (selectedItem) {
      let case_3_12_month_actual_incentive_amount_fte = 0;
      let addl_pay_amount = 0;
      let sum_of_pay_amount = 0;

      if (data.case_3_12_month_actual_incentive_amount_fte !== undefined) {
        case_3_12_month_actual_incentive_amount_fte = isNaN(
          data.case_3_12_month_actual_incentive_amount_fte
        )
          ? 0
          : data.case_3_12_month_actual_incentive_amount_fte;
      }

      
      
      else if (data.request !== undefined && data.request.case_3_12_month_actual_incentive_amount_fte !== undefined) {
        case_3_12_month_actual_incentive_amount_fte = isNaN(data.request.case_3_12_month_actual_incentive_amount_fte) 
        ?  0 : 
        data.request.case_3_12_month_actual_incentive_amount_fte;
        
      }
      else if (selectedItem.case_3_12_month_actual_incentive_amount_fte) { 
        case_3_12_month_actual_incentive_amount_fte = selectedItem.case_3_12_month_actual_incentive_amount_fte; 
      }
      /*  DMND0003988_NBS - Point #7 - Changes Starts  */
      //console.log("selectedItem  2976----->", selectedItem)
      if (selectedItem?.addl_pay_amount != null && selectedItem?.addl_pay_amount != undefined) {
        //console.log("3462");
        addl_pay_amount = Number(selectedItem.addl_pay_amount) || 0;
        //console.log("EDITABLE FUELD VALUE----->", selectedItem.addl_pay_amount)
        if (selectedItem?.lastYearWageHistory != null)
        {
          //console.log("3466");
          selectedItem.lastYearWageHistory.addl_pay_amount = Number(selectedItem.addl_pay_amount) || 0;
        }
           
      }
      else if (selectedItem?.request?.lastYearWageHistory?.addl_pay_amount != null) {
        //console.log("3472");
          addl_pay_amount = Number(
              selectedItem.request.lastYearWageHistory.addl_pay_amount
          ) || 0;
      }
      /*  DMND0003988_NBS - Point #7 - Changes Ends  */
      
      if (selectedItem.lastYearWageHistory !== undefined && selectedItem.lastYearWageHistory !== null && selectedItem.lastYearWageHistory && selectedItem.lastYearWageHistory.addl_pay_amount) {
        //console.log("3480");
        addl_pay_amount = isNaN(selectedItem.lastYearWageHistory.addl_pay_amount)
            ? 0
            : selectedItem.lastYearWageHistory.addl_pay_amount;
      }
      else if (selectedItem.request !== undefined && selectedItem.request !== null && selectedItem.request.lastYearWageHistory !== undefined && selectedItem.request.lastYearWageHistory && selectedItem.request.lastYearWageHistory.addl_pay_amount) {
        //console.log("3486");
        addl_pay_amount = isNaN(selectedItem.request.lastYearWageHistory.addl_pay_amount)
            ? 0
            : selectedItem.request.lastYearWageHistory.addl_pay_amount;
      }
      

      //console.log("case_3_12_month_actual_incentive_amount_fte===>", case_3_12_month_actual_incentive_amount_fte);
      //console.log("addl_pay_amount===>", addl_pay_amount);
      //console.log("request.lastYearWageHistory.addl_pay_amount===>", selectedItem.request.lastYearWageHistory.addl_pay_amount);
      sum_of_pay_amount = case_3_12_month_actual_incentive_amount_fte + addl_pay_amount;
      //console.log("sum_of_pay_amount===>", sum_of_pay_amount);

      // console.log("useMemo sum_of_pay_amount selectedItem", selectedItem);
      // console.log("useMemo sum_of_pay_amount case_3_12_month_actual_incentive_amount_fte", case_3_12_month_actual_incentive_amount_fte);
      // console.log("useMemo sum_of_pay_amount addl_pay_amount", addl_pay_amount);
      // console.log("useMemo sum_of_pay_amount sum_of_pay_amount", sum_of_pay_amount);

      return Math.abs(sum_of_pay_amount);
    }
  }, [selectedItem, data]
  );
  /* Release 3.2 - 13.1 - Ends */

  console.log("OVERRIDE CALCULATION DEBUG:", {
    override_manager_proposal: selectedItem?.override_manager_proposal,
    override_fte_annual_salary: selectedItem?.override_fte_annual_salary,
    override_fte_incentive_target_amount:
      selectedItem?.override_fte_incentive_target_amount,
    calculated_new_fte_annual_salary: new_fte_annual_salary,
    calculated_new_fte_incentive_target_amount:
      new_fte_incentive_target_amount
  });

  const calcData = useMemo(
    () => {
      return {
        salary_range_spread,
        exchange_rate,
        tenure,
        payment_type,
        payment_reason,
        is_gpp_eligible,
        ttc_increase_amount,
        ttc_increase_percentage,
        gpp_increase_amount,
        gpp_increase_percentage,
        gpp_guideline_max,
        promotion_job_family_name,
        promotion_job_subfamily_name,
        promotion_job_name,
        promotion_pay_grade,
        promotion_job_grade,
        promoted,
        demoted,
        promotion_job_grade_delta,
        promotion_incentive_target_percentage,
        mandatory_ttc_increase_percentage,
        mandatory_ttc_increase_amount,
        apply_ti_harmonization,
        interim_harmonization_type,
        interim_job_family_name,
        interim_job_grade,
        interim_pay_grade,
        interim_salary_range_min,
        interim_salary_range_mid,
        interim_salary_range_max,
        interim_salary_range_spread,
        interim_fte_incentive_target_amount,
        interim_incentive_target_percentage,
        interim_total_increase_amount,
        interim_increase_amount_for_salincr,
        interim_increase_amount_for_tih,
        step_1_abs,
        step_1_ita,
        step_1_itp,
        interim_theo_itp,
        interim_itp_situation,
        step_2_abs_gap,
        step_2_ita_gap,
        interim_remainder_for_split,
        new_fte_annual_salary,
        new_fte_incentive_target_amount,
        new_incentive_target_percentage,
        new_fte_ttc_annual_salary,
        new_itp_situation,
        new_ttc_check,
        new_ttc_compa_ratio,
        new_quartile,
        new_incentive_plan_type,
        individual_budget_amount,
        individual_spending_amount,
        individual_balance_amount,
        gpp_budget,
        gpp_spending,
        gpp_balance,
        total_spending,
        offcycle_budget_update,
        override_fte_incentive_target_percentage,
        override_fte_ttc_annual_salary,
        target_budget_org,
        new_position_title,
        ttc_increase,
        ttc_increase_perc,
        transition_allowance,
        /**Release 2 our talent */
        current_combo_situation,
        promo_increase_pct_guideline_min,
        promo_increase_pct_guideline_max,
        promotional_increase_percentage_guideline,
        rr_number,
        case_3_12_month_actual_incentive_amount_fte,
        override_transition_allowance_local_currency,
        internalhire_off_cycle_spending,
        internal_hire_off_cycle_spending_euro,
        is_sip,
        Case_One_Max_Budget_calc,
        Case_one_TTC_increase_minus_Max_budget,
        Case_one_Budget_charge,
        Case_two_TI_Increase,
        Case_two_Promotion_Budget,
        Case_two_Total_budget,
        Case_two_Budget_charge,
        Case_three_twelve_month_Total_Target_Cash,
        Case_three_new_TTC_Gap_to_twelve_month_TTC,
        Case_three_Max_capped_transit_allowance,
        Case_three_Transition_allowance_total,
        Case_three_Budget_charge,
        sip_case,
        Final_Off_Cycle_Budget,
        Final_Off_Cycle_Budget_euro,
        sip_change,
        internalhire_increase_amount,
        internalhire_increase_percentage,
        hiring_manager,
        Max_Promotional_Increase,
        /* Release 3.2 - 13.1 - Starts */
        sum_of_pay_amount,
        /* Release 3.2 - 13.1 - Ends */
      };
    },
    [
      salary_range_spread,
      exchange_rate,
      tenure,
      payment_type,
      payment_reason,
      is_gpp_eligible,
      ttc_increase_amount,
      ttc_increase_percentage,
      gpp_increase_amount,
      gpp_increase_percentage,
      gpp_guideline_max,
      promotion_job_family_name,
      promotion_job_subfamily_name,
      promotion_job_name,
      promotion_pay_grade,
      promotion_job_grade,
      promoted,
      demoted,
      promotion_job_grade_delta,
      promotion_incentive_target_percentage,
      mandatory_ttc_increase_percentage,
      mandatory_ttc_increase_amount,
      apply_ti_harmonization,
      interim_harmonization_type,
      interim_job_family_name,
      interim_job_grade,
      interim_pay_grade,
      interim_salary_range_min,
      interim_salary_range_mid,
      interim_salary_range_max,
      interim_salary_range_spread,
      interim_fte_incentive_target_amount,
      interim_incentive_target_percentage,
      interim_total_increase_amount,
      interim_increase_amount_for_salincr,
      interim_increase_amount_for_tih,
      step_1_abs,
      step_1_ita,
      step_1_itp,
      interim_theo_itp,
      interim_itp_situation,
      step_2_abs_gap,
      step_2_ita_gap,
      interim_remainder_for_split,
      new_fte_annual_salary,
      new_fte_incentive_target_amount,
      new_incentive_target_percentage,
      new_fte_ttc_annual_salary,
      new_itp_situation,
      new_ttc_check,
      new_ttc_compa_ratio,
      new_quartile,
      new_incentive_plan_type,
      individual_budget_amount,
      individual_spending_amount,
      individual_balance_amount,
      gpp_budget,
      gpp_spending,
      gpp_balance,
      total_spending,
      offcycle_budget_update,
      override_fte_incentive_target_percentage,
      override_fte_ttc_annual_salary,
      target_budget_org,
      new_position_title,
      ttc_increase,
      ttc_increase_perc,
      transition_allowance,
      /**Release 2 our talent */
      current_combo_situation,
      promo_increase_pct_guideline_min,
      promo_increase_pct_guideline_max,
      promotional_increase_percentage_guideline,
      rr_number,
      case_3_12_month_actual_incentive_amount_fte,
      override_transition_allowance_local_currency,
      internalhire_off_cycle_spending,
      internal_hire_off_cycle_spending_euro,
      is_sip,
      Case_One_Max_Budget_calc,
      Case_one_TTC_increase_minus_Max_budget,
      Case_one_Budget_charge,
      Case_two_TI_Increase,
      Case_two_Promotion_Budget,
      Case_two_Total_budget,
      Case_two_Budget_charge,
      Case_three_twelve_month_Total_Target_Cash,
      Case_three_new_TTC_Gap_to_twelve_month_TTC,
      Case_three_Max_capped_transit_allowance,
      Case_three_Transition_allowance_total,
      Case_three_Budget_charge,
      sip_case,
      Final_Off_Cycle_Budget,
      Final_Off_Cycle_Budget_euro,
      sip_change,
      internalhire_increase_amount,
      internalhire_increase_percentage,
      hiring_manager,
      Max_Promotional_Increase,
      /* Release 3.2 - 13.1 - Starts */
      sum_of_pay_amount,
      /* Release 3.2 - 13.1 - Ends */
    ]
  );

  /* added below code for resolution for defect #16 and #17--START */

  function isNegative(n) {
    return ((n = +n) || 1 / n) < 0;
  }

  function UpdateN() {

    let ttc_increase_amount = document.querySelectorAll(
      'input[name="ttc_increase_amount"]'
    );
    let ttc_increase_percentage = document.querySelectorAll(
      'input[name="ttc_increase_percentage"]'
    );
    /**Release 2 Our Talent - scenarios change starts */
    let new_fte_annual_salary = document.querySelectorAll(
      'input[name="new_fte_annual_salary"]'
    );
    let new_fte_incentive_target_amount = document.querySelectorAll(
      'input[name="new_fte_incentive_target_amount"]'
    );

    /**Release 2 Our Talent - scenarios change Ends */
    ttc_increase_amount.forEach((e) => {
      let value = e.value;
      if (isNegative(value) || value === 0 || !value || value === "") {
        e.value = "0.00";
      }
    });
    ttc_increase_percentage.forEach((e) => {
      let value = e.value;
      if (isNegative(value) || value === 0 || !value || value === "") {
        e.value = "0.00";
      }
    });
    /**Release 2 Our Talent - scenarios change starts */
    new_fte_annual_salary.forEach((e) => {
      let value = e.value;
      if (isNegative(value) || value === 0 || !value || value === "") {
        e.value = "0.00";
      }
    });
    new_fte_incentive_target_amount.forEach((e) => {
      let value = e.value;
      if (isNegative(value) || value === 0 || !value || value === "") {
        e.value = "0.00";
      }
    });
    /**Release 2 Our Talent - Scenarios Change Ends */
  }

  /* code for resolution for defect #16 and #17--END */


  const updateEmployeeData = useCallback(
    () => {
      if (Object.keys(data).length) {
        const updateData = recordType === 'employees'
          ? { ...data, ...calcData }
          : { request: { ...data.request, ...calcData } };
        updateRecord(item, indexColumn, updateData, recordType);
      }
      /* added below code for resolution for defect #16 and #17--START */
      setTimeout(() => {
        UpdateN();
      }, 300);
      /* code for resolution for defect #16 and #17--END */
    },
    [data, calcData, item, indexColumn, updateRecord, recordType]
  );

  useEffect(() => {
    updateEmployeeData(data, calcData);

  }, [data, calcData, updateEmployeeData]);

  return null;
};

const mapStateToProps = state => {
  return {
    selectedEmployees: state.selectedEmployees,
    selectedRequests: state.selectedRequests,
    config: state.config,
    account: state.account,
    formulas: state.formulas
  };
};

export default connect(
  mapStateToProps,
  { updateRecord }
)(CalculatorNew);
